<template>
  <v-container style="max-width: 100%">
    <v-tabs
      v-model="tabGeneral"
      background-color="transparent"
      color="basil"
      grow
      @change="renderTabCategoriesTypes = Math.random(), changeGeneralTab($event)"
    >
      <v-tab
        v-for="itemTabGeneral in itemsTabGeneral"
        :key="itemTabGeneral"
      >
        <span class="ppc_darkgreen--text">
          {{ itemTabGeneral }}
        </span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabGeneral">
      <v-tab-item>
        <v-card
          flat
          class="d-flex flex-row flex-wrap justify-center"
        >
          <div>
            <v-btn
              class="mx-5 mt-4"
              :disabled="$store.getters.loadingApp === 1"
              @click="changeDate(nowDate)"
            >
              today
            </v-btn>
            <v-btn
              class="mx-5 mt-4"
              :disabled="$store.getters.loadingApp === 1"
              @click="changeDate(addDays(cajaChicaDay, -1))"
            >
              prev day
            </v-btn>
          </div>
          <v-card flat>
            <v-menu
              transition="scale-transition"
              offset-y
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormatted"
                  v-bind="attrs"
                  prepend-icon="$vuetify.icons.icon_mdi_calendar"
                  readonly
                  :disabled="$store.getters.loadingApp === 1"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="cajaChicaDay"
                color="ppc_darkgreen"
                no-title
                scrollable
                @change="changeDate($event)"
              />
            </v-menu>
          </v-card>
          <div>
            <v-btn
              class="mx-5 mt-4"
              :disabled="$store.getters.loadingApp === 1"
              @click="changeDate(addDays(cajaChicaDay, 1))"
            >
              next day
            </v-btn>
            <v-btn
              class="mx-5 mt-4 white--text"
              color="ppc_darkgreen"
              :loading="loadingButton"
              :disabled="$store.getters.loadingApp === 1 || loadingCajas"
              @click="squareCaja"
            >
              square
            </v-btn>
          </div>
        </v-card>
        <v-card
          flat
          class="d-sm-flex flex-row justify-center"
        >
          <v-card
            flat
            class="d-flex flex-column"
          >
            <v-data-table
              :headers="headersIncome"
              :items="incomeDay"
              class="elevation-1 ma-2"
              disable-pagination
              hide-default-footer
              sort-by="dateTime"
              dense
              style="min-width: 40vw;"
              :item-class="itemRowBackgroundIncome"
            >
              <template v-slot:[`item.payerName`]="{ item }">
                <span v-if="item.client_id !== null"><v-btn
                  x-small
                  rounded
                  @click="goClient(item.client_id)"
                >{{ item.payerName }}</v-btn></span>
                <span v-else>{{ item.payerName }}</span>
              </template>
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-tooltip
                    v-if="checkShow()"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="ppc_darkgreen"
                        dark
                        x-small
                        class="mr-4"
                        fab
                        @click="newEditIncome(null, null, null, null)"
                        v-on="on"
                      >
                        <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Add new Income</span>
                  </v-tooltip>
                  <v-toolbar-title>Income Caja</v-toolbar-title>
                  <v-spacer />

                  <h3
                    v-if="hasDayIncomeDollars"
                    class="mr-4"
                  >
                    ${{ dayIncomeDollarsFormatted }}
                  </h3>

                  <h3 v-if="hasDayIncomeSoles">
                    S/.{{ dayIncomeSolesFormatted }}
                  </h3>
                </v-toolbar>
              </template>
              <template v-slot:[`item.payment`]="{ item }">
                <span v-if="item.amount">{{ item.currency }} {{ decUtil.format(item.amount) }}</span>
              </template>
              <template v-slot:[`item.allDistributed`]="{ item }">
                <v-icon
                  v-if="item.allDistributed === 'ok'"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
                <span
                  v-else
                  v-html="item.allDistributed"
                />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div
                  v-if="!item.idSquare"
                  class="d-flex flex-row"
                >
                  <v-icon
                    small
                    class="mr-2"
                    :disabled="$store.getters.loadingApp === 1"
                    @click="editIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    :disabled="item.frozen || $store.getters.loadingApp === 1"
                    @click="deleteIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                </div>
              </template>
            </v-data-table>
          </v-card>
          <v-card
            flat
            class="d-flex flex-column"
          >
            <v-data-table
              :headers="headersOutgoings"
              :items="outgoingsDay"
              class="elevation-1 ma-2"
              disable-pagination
              hide-default-footer
              sort-by="dateTime"
              dense
              style="min-width: 40vw;"
              :item-class="itemRowBackgroundOutgoings"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-tooltip
                    v-if="checkShow()"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="blue"
                        dark
                        class="mr-4"
                        x-small
                        fab
                        @click="newEditOutgoing(null)"
                        v-on="on"
                      >
                        <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Add new Outgoing</span>
                  </v-tooltip>
                  <v-toolbar-title>Outgoings Caja</v-toolbar-title>
                  <v-spacer />

                  <h3
                    v-if="hasDayOutgoingsDollars"
                    class="mr-4"
                  >
                    ${{ dayOutgoingsDollarsFormatted }}
                  </h3>

                  <h3 v-if="hasDayOutgoingsSoles">
                    S/.{{ dayOutgoingsSolesFormatted }}
                  </h3>
                </v-toolbar>
              </template>
              <template v-slot:[`item.payment`]="{ item }">
                <span v-if="item.amount">{{ item.currency }} {{ decUtil.format(item.amount) }}</span>
              </template>
              <template v-slot:[`item.receiverName`]="{ item }">
                <span v-if="item.payerClient !== null"><v-btn
                  x-small
                  rounded
                  @click="goClient(item.payerClient)"
                >{{ item.receiverName }}</v-btn></span>
                <span v-else>{{ item.receiverName }}</span>
              </template>
              <template v-slot:[`item.allDistributed`]="{ item }">
                <v-icon
                  v-if="item.allDistributed === 'ok'"
                  small
                  color="ppc_darkgreen"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
                <span
                  v-else
                  v-html="item.allDistributed"
                />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div
                  v-if="!item.idSquare"
                  class="d-flex flex-row"
                >
                  <v-icon
                    small
                    class="mr-2"
                    :disabled="$store.getters.loadingApp === 1"
                    @click="editOutgoing(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    :disabled="item.frozen || $store.getters.loadingApp === 1"
                    @click="deleteOutgoing(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                  <v-icon
                    v-if="!item.idSquare && (item.type_id === 12 || item.type_id === 13 || item.type_id === 32)"
                    small
                    class="mr-2"
                    @click="createPaymentTeacherForm(item)"
                  >
                    mdi-file-chart
                  </v-icon>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
        <v-row
          justify="center"
          class="d-flex flex-row flex-wrap"
        >
          <h6>Total end of the Day</h6>
        </v-row>
        <v-divider />
        <div class="d-flex flex-row flex-wrap mt-8">
          <v-card-title>
            End of Day
          </v-card-title>
          <v-card flat>
            <v-card-subtitle>
              Caja Chica
            </v-card-subtitle>
            <v-card-text>
              <div
                v-if="hasCashSoles"
                class="mr-4"
              >
                S/.{{ cashSolesFormatted }}
              </div>
              <div v-if="hasCashDollars">
                ${{ cashDollarsFormatted }}
              </div>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-subtitle>
              Caja Fuerte
            </v-card-subtitle>
            <v-card-text>
              <div v-if="hasBankSoles">
                S/.{{ bankSolesFormatted }}
              </div>
              <div v-if="hasBankDollars">
                ${{ bankDollarsFormatted }}
              </div>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-subtitle>
              Outstanding Deposits
            </v-card-subtitle>
            <v-btn
              small
              class="mt-2 ml-6"
              :loading="loadingCajas"
              width="75px"
              @click="dialogSecurityDeposits = true"
            >
              <div v-if="hasOutstandingDepositsTotal">
                ${{ outstandingDepositsTotalFormatted }}
              </div>
            </v-btn>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-tabs
          v-model="tabTransactions"
          background-color="transparent"
          color="basil"
          grow
        >
          <v-tab>
            <span class="ppc_darkgreen--text">
              Income
            </span>
          </v-tab>
          <v-tab>
            <span class="blue--text">
              Outgoings
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabTransactions">
          <v-tab-item>
            <v-row
              justify="center"
              class="pa-4"
            >
              <v-btn
                color="grey"
                small
                class="ma-2"
                :loading="loadingbuttonLoadTransactionsOpen"
                :disabled="loadingbuttonLoadTransactionsClosed"
                @click="getTransactionsIncome('open')"
              >
                <span class="white--text">Load Open Transactions Income</span>
              </v-btn>
              <v-btn
                color="grey"
                small
                class="ma-2"
                :loading="loadingbuttonLoadTransactionsClosed"
                :disabled="loadingbuttonLoadTransactionsOpen"
                @click="getTransactionsIncome('all')"
              >
                <span class="white--text">Load All Transactions Income</span>
              </v-btn>
            </v-row>
            <v-data-table
              v-if="transactionsIncome.length > 0"
              :headers="headersTransactionsIncome"
              :items="transactionsIncome"
              class="elevation-1 ma-2"
              sort-by="dateTime"
              dense
              :items-per-page="-1"
            >
              <template v-slot:[`item.totalPriceTransaction`]="{ item }">
                <span v-if="item.totalPriceTransaction">{{ decUtil.format(item.totalPriceTransaction) }}</span>
              </template>
              <template v-slot:[`item.amountPaidTransaction`]="{ item }">
                <span v-if="item.amountPaidTransaction">{{ decUtil.format(item.amountPaidTransaction) }}</span>
              </template>
              <template v-slot:[`item.transactionClosed`]="{ item }">
                <v-icon
                  v-if="item.transactionClosed === 1"
                  small
                  color="ppc_darkgreen"
                  class="mr-2"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.id`]="{ item }">
                <span v-html="formattedDate(item.id, 'dateAndTime')" />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  :disabled="item.amountPaidTransaction===0"
                  @click="openDialogTransactionIncome(item.id)"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-row
              justify="center"
              class="pa-4"
            >
              <v-btn
                color="grey"
                small
                class="ma-2"
                :loading="loadingbuttonLoadTransactionsOpen"
                :disabled="loadingbuttonLoadTransactionsClosed"
                @click="loadTransactionsOutgoings('open')"
              >
                <span class="white--text">Load Open Transactions Outgoings</span>
              </v-btn>
              <v-btn
                color="grey"
                small
                class="ma-2"
                :loading="loadingbuttonLoadTransactionsClosed"
                :disabled="loadingbuttonLoadTransactionsOpen"
                @click="loadTransactionsOutgoings('all')"
              >
                <span class="white--text">Load All Transactions Outgoings</span>
              </v-btn>
            </v-row>
            <v-data-table
              v-if="transactionsOutgoings.length > 0"
              :headers="headersTransactionsOutgoings"
              :items="transactionsOutgoings"
              class="elevation-1 ma-2"
              sort-by="dateTime"
              dense
              :items-per-page="-1"
            >
              <template v-slot:[`item.payerName`]="{ item }">
                <v-btn
                  v-if="item.payerName===''"
                  @click="goApplication(item.application_id)"
                >
                  {{ item.payerName }}
                </v-btn>
                <span v-else>{{ item.payerName }}</span>
              </template>
              <template v-slot:[`item.totalPaymentTransactionSoles`]="{ item }">
                <span v-if="hasMoney(item.totalPaymentTransactionDollars)">
                  ${{ formatMoney(item.totalPaymentTransactionDollars) }}
                </span>
                <span v-if="hasMoney(item.totalPaymentTransactionSoles)">
                  S/.{{ formatMoney(item.totalPaymentTransactionSoles) }}
                </span>
              </template>
              <template v-slot:[`item.amountSoles`]="{ item }">
                <span v-if="hasMoney(item.amountDollars)">
                  {{ formatMoney(item.amountDollars) }}
                </span>
                <span v-if="hasMoney(item.amountSoles)">
                  ({{ formatMoney(item.amountSoles) }})
                </span>
              </template>
              <template v-slot:[`item.transactionClosed`]="{ item }">
                <v-icon
                  v-if="item.transactionClosed === 1"
                  small
                  color="ppc_darkgreen"
                  class="mr-2"
                >
                  $vuetify.icons.icon_mdi_check
                </v-icon>
              </template>
              <template v-slot:[`item.id`]="{ item }">
                <span v-html="formattedDate(item.id, 'dateAndTime')" />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDialogTransactionOutgoings(item.id)"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          class="d-flex flex-row flex-wrap justify-space-around my-8"
        >
          <v-card
            flat
            class="d-flex flex-row flex-wrap mb-0"
          >
            <v-text-field
              v-model="balanceGeneralYear"
              prepend-icon="$vuetify.icons.icon_mdi_calendar"
              single-line
              type="number"
              style="width: 100px"
              :rules="[v => v >= 2020 || 'The value must be a bigger than 2020']"
              @change="getDataMonth(tabMonth)"
              @click="getDataMonth(tabMonth)"
            />
            <v-btn 
              v-if="this.$store.state.accessCajaGrande === 1"
              small
              class="my-5 mx-8"
              @click="openAnnualReport()"
            >
              Annual Report
            </v-btn>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              :return-value.sync="lockedFinancialMonth"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="lockedFinancialMonth"
                  label="Closed until"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  color="red"
                  style="width: 100px"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="lockedFinancialMonth"
                type="month"
                no-title
                scrollable
                color="red"
              >
                <v-spacer />
                <v-btn
                  text
                  color="red"
                  @click="$refs.menu.save(lockedFinancialMonth), saveFinancialLocked()"
                >
                  Save
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-card>
          <v-card
            flat
            class="my-2"
          >
            <v-expansion-panels
              v-if="$store.state.showBank === 1 || $store.state.showWise === 1"
              v-model="hideTotals"
              style="width: 1000px"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Accounts Totals
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex flex-row flex-wrap justify-space-around">
                    <v-card
                      v-if="$store.state.showBank === 1"
                      flat
                    >
                      <v-card-subtitle>
                        Bank
                      </v-card-subtitle>
                      <v-card-text
                        class="d-flex flex-row flex-wrap justify-space-around"
                      >
                        <v-btn
                          small
                          class="mt-2"
                          :loading="loadingCajas"
                          width="150px"
                          @click="openReportValutaYear(&quot;solesBank&quot;)"
                        >
                          <div v-if="hasCashSoles">
                            S/.{{ cashSolesFormatted }}
                          </div>
                        </v-btn>
                        <v-btn
                          small
                          class="mt-2"
                          :loading="loadingCajas"
                          width="150px"
                          @click="openReportValutaYear(&quot;dollarsBank&quot;)"
                        >
                          <div v-if="hasCashDollars">
                            ${{ cashDollarsFormatted }}
                          </div>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                    <v-card
                      v-if="$store.state.showWise === 1"
                      flat
                    >
                      <v-card-subtitle>
                        Wise
                      </v-card-subtitle>
                      <v-card-text
                        class="d-flex flex-row flex-wrap justify-space-around"
                      >
                        <v-btn
                          small
                          class="mt-2"
                          :loading="loadingCajas"
                          width="150px"
                          @click="openReportValutaYear(&quot;dollarsWise&quot;)"
                        >
                          <div v-if="hasWiseDollars">
                            ${{ wiseDollarsFormatted }}
                          </div>
                        </v-btn>

                        <v-btn
                          small
                          class="mt-2"
                          :loading="loadingCajas"
                          width="150px"
                          @click="openReportValutaYear(&quot;eurosWise&quot;)"
                        >
                          <div v-if="hasWiseEuros">
                            €{{ wiseEurosFormatted }}
                          </div>
                        </v-btn>

                        <v-btn
                          small
                          class="mt-2"
                          :loading="loadingCajas"
                          width="150px"
                          @click="openReportValutaYear(&quot;gbpWise&quot;)"
                        >
                          <div v-if="hasWiseGbp">
                            £{{ wiseGbpFormatted }}
                          </div>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-card>
        <v-tabs
          v-model="tabMonth"
          background-color="blue-grey lighten-5"
          color="basil"
          dark
          grow
          @change="getDataMonth($event)"
        >
          <v-tab
            v-for="itemTabMonth in itemsTabMonths"
            :key="itemTabMonth"
          >
            <span class="grey--text darken-2">
              {{ itemTabMonth }}
            </span>
          </v-tab>
        </v-tabs>
        <!-- Months -->
        <v-tabs-items v-model="tabMonth">
          <v-tab-item
            v-for="itemTabMonth in itemsTabMonths"
            :key="itemTabMonth"
          >
            <v-tabs
              v-model="tabIncomeOutgoing"
              background-color="transparent"
              color="basil"
              grow
              class="mt-4"
            >
              <v-tab>
                <v-tooltip
                  v-if="checkShow()"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="ppc_darkgreen"
                      dark
                      x-small
                      absolute
                      left
                      fab
                      @click="newEditIncome(null, null, null, null)"
                      v-on="on"
                    >
                      <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Add new Income</span>
                </v-tooltip>
                <span class="ppc_darkgreen--text">
                  Income
                </span>
              </v-tab>
              <v-tab>
                <v-tooltip
                  v-if="checkShow()"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="blue"
                      dark
                      x-small
                      absolute
                      right
                      fab
                      @click="newEditOutgoing(null)"
                      v-on="on"
                    >
                      <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Add new Outgoing</span>
                </v-tooltip>
                <span class="blue--text">
                  Outgoings
                </span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabIncomeOutgoing">
              <v-tab-item>
                <v-data-table
                  :headers="headersIncomeMonth"
                  :items="incomeMonth"
                  class="elevation-1 ma-2"
                  disable-pagination
                  hide-default-footer
                  sort-by="dateTime"
                  dense
                  :item-class="itemRowBackgroundIncome"
                >
                  <template v-slot:[`item.payment`]="{ item }">
                    <span v-if="item.amount">{{ item.currency }} {{ decUtil.format(item.amount) }}</span>
                  </template>
                  <template v-slot:[`item.payerName`]="{ item }">
                    <span v-if="item.client_id !== null"><v-btn
                      x-small
                      rounded
                      @click="goClient(item.client_id)"
                    >{{ item.payerName }}</v-btn></span>
                    <span v-else>{{ item.payerName }}</span>
                  </template>
                  <template v-slot:[`item.allDistributed`]="{ item }">
                    <v-icon
                      v-if="item.allDistributed === 'ok'"
                      small
                      color="ppc_darkgreen"
                    >
                      $vuetify.icons.icon_mdi_check
                    </v-icon>
                    <span
                      v-else
                      v-html="item.allDistributed"
                    />
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <span class="d-flex flex-row">
                      <v-icon
                        v-if="!item.idSquare"
                        small
                        class="mr-2"
                        @click="editIncome(item)"
                      >
                        $vuetify.icons.icon_mdi_pencil
                      </v-icon>
                      <v-icon
                        small
                        :disabled="item.frozen"
                        @click="deleteIncome(item)"
                      >
                        $vuetify.icons.icon_mdi_delete
                      </v-icon>
                    </span>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headersOutgoingsMonth"
                  :items="outgoingsMonth"
                  class="elevation-1 ma-2"
                  disable-pagination
                  hide-default-footer
                  sort-by="dateTime"
                  dense
                  :item-class="itemRowBackgroundOutgoings"
                >
                  <template v-slot:[`item.payment`]="{ item }">
                    <span v-if="hasMoney(totalPaymentAmount(item))">
                      {{ item.currency }} {{ formatMoney(totalPaymentAmount(item)) }}
                    </span>
                  </template>
                  <template v-slot:[`item.receiverName`]="{ item }">
                    <span v-if="item.payerClient !== null"><v-btn
                      x-small
                      rounded
                      @click="goClient(item.payerClient)"
                    >{{ item.receiverName }}</v-btn></span>
                    <span v-else>{{ item.receiverName }}</span>
                  </template>
                  <template v-slot:[`item.allDistributed`]="{ item }">
                    <v-icon
                      v-if="item.allDistributed === 'ok'"
                      small
                      color="ppc_darkgreen"
                    >
                      $vuetify.icons.icon_mdi_check
                    </v-icon>
                    <span
                      v-else
                      v-html="item.allDistributed"
                    />
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <span class="d-flex flex-row">
                      <v-icon
                        v-if="!item.idSquare"
                        small
                        class="mr-2"
                        @click="editOutgoing(item)"
                      >
                        $vuetify.icons.icon_mdi_pencil
                      </v-icon>
                      <v-icon
                        small
                        class="mr-2"
                        :disabled="item.frozen"
                        @click="deleteOutgoing(item)"
                      >
                        $vuetify.icons.icon_mdi_delete
                      </v-icon>
                      <v-icon
                        v-if="!item.idSquare && (item.type_id === 12 || item.type_id === 13 || item.type_id === 32)"
                        small
                        class="mr-2"
                        @click="createPaymentTeacherForm(item)"
                      >
                        mdi-file-chart
                      </v-icon>
                    </span>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
        </v-tabs-items>         
      </v-tab-item>
      <v-tab-item>
        <v-tabs
          v-model="tabCategoriesTypes"
          background-color="transparent"
          color="basil"
          grow
        >
          <v-tab>
            <span class="ppc_darkgreen--text">
              Income
            </span>
          </v-tab>
          <v-tab>
            <span class="blue--text">
              Outgoings
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items
          :key="renderTabCategoriesTypes"
          v-model="tabCategoriesTypes"
        >
          <v-tab-item>
            <div class="d-flex flex-row mt-4">
              <v-data-table
                :headers="headersCategoriesIncome"
                :items="categoriesIncome"
                class="elevation-1 ma-2"
                disable-pagination
                hide-default-footer
                sort-by="name"
                dense
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title>Categories</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.obsolete`]="{ item }">
                  <v-icon
                    v-if="item.obsolete !== null"
                    small
                    color="ppc_pink"
                  >
                    $vuetify.icons.icon_mdi_cancel
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editCategoryIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteCategoryIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headersTypesIncome"
                :items="typesIncome"
                class="elevation-1 ma-2"
                disable-pagination
                hide-default-footer
                sort-by="name"
                dense
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title>Types</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                    <v-btn
                      color="ppc_darkgreen"
                      dark
                      small
                      absolute
                      right
                      fab
                      @click="dialogTypeIncome=true"
                    >
                      <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                    </v-btn>
                    <v-dialog
                      v-model="dialogTypeIncome"
                      max-width="500px"
                      persistent
                    >
                      <v-form ref="dialogTypeIncomeForm">
                        <v-card class="d-flex flex-column">
                          <v-card-title class="ppc_darkgreen darken-1">
                            <span class="headline white--text">{{ formTitleTypeIncome }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-text-field
                              v-model.trim="editedTypeIncomeItem.name"
                              label="Name"
                              counter="45"
                              :rules="inputRulesName"
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeIncomeItem.category_id"
                              :items="selectCategoriesIncome"
                              item-text="name"
                              item-value="id"
                              :menu-props="{ auto: true }"
                              label="Select category"
                              single-line
                              validate-on-blur
                              :rules="inputRulesReq"
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeIncomeItem.payer"
                              :items="selectPayer"
                              item-text="name"
                              item-value="value"
                              :menu-props="{ auto: true }"
                              label="Select Payer"
                              single-line
                              validate-on-blur
                              :rules="inputRulesReq"
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeIncomeItem.paymentMethod"
                              :items="selectPaymentMethods()"
                              item-text="method"
                              item-value="id"
                              :menu-props="{ auto: true }"
                              label="Select Payment Method"
                              single-line
                              validate-on-blur
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-checkbox
                              v-model="editedTypeIncomeItem.accountable"
                              :input-value="editedTypeIncomeItem.accountable === 1"
                              label="Accounted for with Applications"
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-checkbox
                              v-model="editedTypeIncomeItem.showCajaChica"
                              :input-value="editedTypeIncomeItem.showCajaChica === 1"
                              label="Show in Caja Chica"
                            />
                            <v-checkbox
                              v-model="editedTypeIncomeItem.fixed"
                              label="Fix (nobody can change it later)"
                              :disabled="editedTypeIncomeItem.fixed === 1"
                            />
                            <v-textarea
                              v-model="editedTypeIncomeItem.description"
                              class="rounded-xl ma-3"
                              auto-grow
                              clearable
                              counter="255"
                              outlined
                              label="Description (255 max)"
                              :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                            />
                            <v-checkbox
                              :input-value="editedTypeIncomeItem.obsolete !== null"
                              label="Obsolete"
                              @change="setObsoleteTypeIncome($event)"
                            />
                            <v-text-field
                              v-if="editedTypeIncomeItem.obsolete !== null"
                              :value="formattedDate(editedTypeIncomeItem.obsolete)"
                              disabled
                              label="From"
                              class="ml-2"
                            />
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              color="ppc_darkgreen darken-1"
                              text
                              @click="closeTypeIncome"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="ppc_darkgreen darken-1"
                              text
                              @click="saveTypeIncome"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-form>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogTypeIncomeDelete"
                      max-width="500px"
                    >
                      <v-card>
                        <v-card-title>Are you sure you want to delete {{ editedTypeIncomeItem.name }}?</v-card-title>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="ppc_darkgreen darken-1"
                            text
                            @click="closeDeleteTypeIncome"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="ppc_darkgreen darken-1"
                            text
                            @click="deleteTypeIncomeConfirm"
                          >
                            OK
                          </v-btn>
                          <v-spacer />
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.accountable`]="{ item }">
                  <v-icon
                    v-if="item.accountable === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.paymentMethod`]="{ item }">
                  <v-icon
                    v-if="!item.paymentMethod"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.showCajaChica`]="{ item }">
                  <v-icon
                    v-if="item.showCajaChica === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.fixed`]="{ item }">
                  <v-icon
                    v-if="item.fixed === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.obsolete`]="{ item }">
                  <v-icon
                    v-if="item.obsolete !== null"
                    small
                    color="ppc_pink"
                  >
                    $vuetify.icons.icon_mdi_cancel
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editTypeIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    :disabled="item.used !== 0"
                    @click="deleteTypeIncome(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                </template>
              </v-data-table>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="d-flex flex-row mt-4">
              <v-data-table
                :headers="headersCategoriesOutgoings"
                :items="categoriesOutgoings"
                class="elevation-1 ma-2"
                disable-pagination
                hide-default-footer
                sort-by="name"
                dense
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title>Categories</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.obsolete`]="{ item }">
                  <v-icon
                    v-if="item.obsolete !== null"
                    small
                    color="ppc_pink"
                  >
                    $vuetify.icons.icon_mdi_cancel
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editCategoryOutgoings(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteCategoryOutgoings(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headersTypesOutgoings"
                :items="typesOutgoings"
                class="elevation-1 ma-2"
                disable-pagination
                hide-default-footer
                sort-by="name"
                dense
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title>Types</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                    <v-btn
                      color="blue"
                      dark
                      small
                      absolute
                      right
                      fab
                      @click="dialogTypeOutgoings=true"
                    >
                      <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                    </v-btn>
                    <v-dialog
                      v-model="dialogTypeOutgoings"
                      max-width="500px"
                      persistent
                    >
                      <v-form ref="dialogTypeOutgoingsForm">
                        <v-card class="d-flex flex-column">
                          <v-card-title class="blue darken-1">
                            <span class="headline white--text">{{ formTitleTypeOutgoings }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-text-field
                              v-model.trim="editedTypeOutgoingsItem.name"
                              label="Name"
                              counter="45"
                              :rules="inputRulesName"
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeOutgoingsItem.category_id"
                              :items="selectCategoriesOutgoings"
                              item-text="name"
                              item-value="id"
                              :menu-props="{ auto: true }"
                              label="Select category"
                              single-line
                              validate-on-blur
                              :rules="inputRulesReq"
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeOutgoingsItem.receiver"
                              :items="selectReceiver"
                              item-text="name"
                              item-value="value"
                              :menu-props="{ auto: true }"
                              label="Select Receiver"
                              single-line
                              validate-on-blur
                              :rules="inputRulesReq"
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeOutgoingsItem.contact_id"
                              v-if="editedTypeOutgoingsItem.receiver === 'Fixed Contact'"
                              :items="$store.state.contacts"
                              item-text="full_name"
                              item-value="id"
                              :menu-props="{ auto: true }"
                              label="Select Fixed Contact"
                              single-line
                              prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
                              validate-on-blur
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-select
                              v-model="editedTypeOutgoingsItem.paymentMethod"
                              :items="selectPaymentMethods()"
                              item-text="method"
                              item-value="id"
                              :menu-props="{ auto: true }"
                              label="Select Payment Method"
                              single-line
                              validate-on-blur
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-checkbox
                              v-model="editedTypeOutgoingsItem.accountable"
                              :input-value="editedTypeOutgoingsItem.accountable === 1"
                              label="Accounted for with Resources"
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-checkbox
                              v-model="editedTypeOutgoingsItem.showCajaChica"
                              :input-value="editedTypeOutgoingsItem.showCajaChica === 1"
                              label="Show in Caja Chica"
                            />
                            <v-checkbox
                              v-model="editedTypeOutgoingsItem.fixed"
                              label="Fix (nobody can change it later)"
                              :disabled="editedTypeOutgoingsItem.fixed === 1"
                            />
                            <v-textarea
                              v-model="editedTypeOutgoingsItem.description"
                              class="rounded-xl ma-3"
                              auto-grow
                              clearable
                              counter="255"
                              outlined
                              label="Description (255 max)"
                              :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                            />
                            <v-checkbox
                              :input-value="editedTypeOutgoingsItem.obsolete !== null"
                              label="Obsolete"
                              @change="setObsoleteTypeOutgoings($event)"
                            />
                            <v-text-field
                              v-if="editedTypeOutgoingsItem.obsolete !== null"
                              :value="formattedDate(editedTypeOutgoingsItem.obsolete)"
                              disabled
                              label="From"
                              class="ml-2"
                            />
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              color="ppc_darkgreen darken-1"
                              text
                              @click="closeTypeOutgoings"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="ppc_darkgreen darken-1"
                              text
                              @click="saveTypeOutgoings"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-form>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogTypeOutgoingsDelete"
                      max-width="500px"
                    >
                      <v-card>
                        <v-card-title>Are you sure you want to delete {{ editedTypeOutgoingsItem.name }}?</v-card-title>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="ppc_darkgreen darken-1"
                            text
                            @click="closeDeleteTypeOutgoings"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="ppc_darkgreen darken-1"
                            text
                            @click="deleteTypeOutgoingsConfirm"
                          >
                            OK
                          </v-btn>
                          <v-spacer />
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.accountable`]="{ item }">
                  <v-icon
                    v-if="item.accountable === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.paymentMethod`]="{ item }">
                  <v-icon
                    v-if="!item.paymentMethod"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.showCajaChica`]="{ item }">
                  <v-icon
                    v-if="item.showCajaChica === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.fixed`]="{ item }">
                  <v-icon
                    v-if="item.fixed === 1"
                    small
                    color="ppc_darkgreen"
                  >
                    $vuetify.icons.icon_mdi_check
                  </v-icon>
                </template>
                <template v-slot:[`item.obsolete`]="{ item }">
                  <v-icon
                    v-if="item.obsolete !== null"
                    small
                    color="ppc_pink"
                  >
                    $vuetify.icons.icon_mdi_cancel
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editTypeOutgoings(item)"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  <v-icon
                    small
                    :disabled="item.used !== 0"
                    @click="deleteTypeOutgoings(item)"
                  >
                    $vuetify.icons.icon_mdi_delete
                  </v-icon>
                </template>
              </v-data-table>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
    </v-tabs-items>
        
    <v-dialog
      v-model="dialogEditIncome"
      max-width="900px"
      persistent
    >
      <v-card
        :key="renderDialog"
        flat
        class="d-flex flex-column"
      >
        <v-card-title class="ppc_darkgreen darken-1 white--text">

          <div v-if="editingIncome">
            Edit Income
          </div>
          <div v-else>
            Add Income
          </div>
          
        </v-card-title>
        <v-form
          ref="formIncome"
          flat
          class="d-flex flex-column pa-5"
        >
          <v-card-actions
            class="d-flex flex-column"
            style="width: 100%"
          >
            <v-card flat>
              <v-menu
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate(editedIncomeItem.dateTime)"
                    v-bind="attrs"
                    prepend-icon="$vuetify.icons.icon_mdi_calendar"
                    readonly
                    :disabled="editedIncomeItem.frozen"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="editedIncomeItem.dateTime"
                  color="ppc_darkgreen"
                  no-title
                  scrollable
                  :max="nowDate"
                  :min="financialFirstOpenDay"
                  :disabled="editedIncomeItem.frozen"
                />
              </v-menu>
            </v-card>
            <v-card flat>
              <v-select
                v-model="editedIncomeItem.type_id"
                style="width: 400px"
                :items="selectTypesIncome()"
                item-text="name"
                item-value="id"
                :menu-props="{ auto: true }"
                label="type of income"
                single-line
                prepend-icon="mdi-arrow-right-thick ppc_darkgreen--text"
                validate-on-blur
                clearable
                class="mr-4"
                :rules="inputRulesReq"
                :disabled="distributionsIncomeNew.length > 0 || editedIncomeItem.frozen"
                @change="changeIncomeType()"
              />
            </v-card>
            <v-card-subtitle style="width: 100%">
              <v-divider />
            </v-card-subtitle>
            <v-card
              flat
              class="d-flex flex-row flex-wrap mb-4"
              :disabled="distributionsIncomeNew.length > 0 || tabGeneral === 1"
            >
              <v-select
                v-model="editedIncomeItem.client_id"
                style="width: 250px"
                :items="selectClients"
                item-text="full_name"
                v-if="editedIncomeItem.type_id && editedIncomeItem.payer === 'Client'"
                item-value="id"
                :menu-props="{ auto: true }"
                label="client"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_account ppc_darkgreen--text"
                validate-on-blur
                clearable
                class="mr-4"
                :disabled="editedIncomeItem.frozen"
                @change="choosePayer('client')"
              />
              <v-select
                v-model="editedIncomeItem.agency_id"
                style="width: 250px"
                :items="selectAvailableAgencies()"
                item-text="name"
                v-if="editedIncomeItem.type_id && editedIncomeItem.payer === 'Client Agency'"
                item-value="id"
                :menu-props="{ auto: true }"
                label="agency"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_domain ppc_darkgreen--text"
                validate-on-blur
                clearable
                class="mr-4"
                :disabled="editedIncomeItem.frozen"
                @change="choosePayer('agency')"
              />
              <v-select
                v-model="editedIncomeItem.contact_id"
                style="width: 250px"
                :items="selectContactsIncome()"
                item-text="full_name"
                v-if="editedIncomeItem.type_id && editedIncomeItem.payer === 'Contact'"
                item-value="id"
                :menu-props="{ auto: true }"
                label="contact"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
                validate-on-blur
                clearable
                class="mr-4"
                :disabled="editedIncomeItem.frozen"
                @change="choosePayer('contact')"
              />
            </v-card>
            <v-select
              v-model="editedIncomeItem.paymentMethod"
              style="width: 250px"
              :items="selectPaymentMethods()"
              item-text="method"
              v-if="tabGeneral === 1 || tabGeneral === 2"
              item-value="id"
              :menu-props="{ auto: true }"
              label="payment method"
              single-line
              prepend-icon="$vuetify.icons.icon_mdi_credit_card_outline ppc_darkgreen--text"
              validate-on-blur
              clearable
              class="mr-4"
              :rules="inputRulesReq"
              :disabled="editedIncomeItem.fixedPaymentMethod === 1 || !editedIncomeItem.type_id || distributionsIncomeNew.length > 0 || editedIncomeItem.frozen"
            />
            <v-radio-group
              v-if="editedIncomeItem.type_id !== 29 && editedIncomeItem.type_id !== 30"
              v-model="editedIncomeItem.currency"
              row
              label="Currency of payment"
              :rules="inputRulesReq"
              :disabled="distributionsIncomeNew.length > 0 || editedIncomeItem.frozen"
            >
              <v-radio
                v-if="editedIncomeItem.type_id !== 22"
                label="$"
                value="$"
              />
              <v-radio
                v-if="editedIncomeItem.paymentMethod !== 2"
                label="PEN"
                value="S/."
              />
              <v-radio
                v-if="editedIncomeItem.paymentMethod === 2"
                label="€"
                value="€"
              />
              <v-radio
                v-if="editedIncomeItem.paymentMethod === 2"
                label="£"
                value="£"
              />
            </v-radio-group>
            <v-card
              flat
              class="d-flex flex-row flex-wrap"
            >
              <v-card
                flat
                class="d-flex flex-row ma-2 pa-4 rounded-xl"
              >
                <span class="mt-2">{{ editedIncomeItem.currency }}</span>
                <v-text-field
                  v-model="editedIncomeItem.amount"
                  class="pa-0 ml-1 mr-2"
                  label="amount received"
                  clearable
                  :rules="numberRule"
                  :disabled="distributionsIncomeNew.length > 0 || editedIncomeItem.frozen"
                  style="width: 150px"
                />
                <span
                  v-if="editedIncomeItem.currency === '$'"
                  class="mt-2"
                />
                <span
                  v-if="editedIncomeItem.currency === 'S/.'"
                  class="mt-2"
                >(equals today ${{ equalInDollars }})</span>
                <span
                  v-if="editedIncomeItem.currency === '€' && rateEUR !== null"
                  class="mt-2"
                >(equals today ${{ equalInDollars }})</span>
                <span
                  v-if="editedIncomeItem.currency === '£' && rateGBP !== null"
                  class="mt-2"
                >(equals today ${{ equalInDollars }})</span>
              </v-card>
              <div v-if="editedIncomeItem.type_id !== 81">
                <v-card
                  flat
                  class="ma-2 pa-4 rounded-xl"
                >
                  <v-text-field
                    v-model="editedIncomeItem.bankTransferFee"
                    class="pa-0 mr-2"
                    label="bank transfer fee"
                    clearable
                    :disabled="editedIncomeItem.frozen"
                    style="width: 150px"
                  />
                </v-card>
                <v-card
                  v-if="transferFeeIncluded === 1"
                  flat
                  class="mt-8"
                >
                  Included!
                </v-card>
              </div>
            </v-card>
            <v-card
              flat
              class="d-flex flex-row flex wrap"
              :disabled="editedIncomeItem.accountable === 0 || (!editedIncomeItem.client_id && !editedIncomeItem.agency_id) || !editedIncomeItem.amount"
            >
              <v-tooltip
                v-if="checkShow()"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="ppc_pink"
                    fab
                    :disabled="editedIncomeItem.frozen"
                    dark
                    x-small
                    bottom
                    @click="openAddDistributionsIncome"
                    v-on="on"
                  >
                    <v-icon color="white">
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>add distribution</span>
              </v-tooltip>
              <v-card
                flat
                class="d-flex flex-column"
              >
                <v-data-table
                  :headers="headersDistributionsIncome"
                  :items="distributionsIncomeNew"
                  class="ma-4"
                  disable-pagination
                  hide-default-footer
                  dense
                >
                  <template v-slot:[`item.totalPrice`]="{ item }">
                    <span v-if="item.totalPrice">${{ decUtil.format(item.totalPrice) }}</span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span v-if="item.amount">${{ decUtil.format(item.amount) }}</span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      :disabled="item.transactionStatus === 'closed' || editedIncomeItem.frozen"
                      @click="deleteDistributionIncome(item)"
                    >
                      $vuetify.icons.icon_mdi_delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-divider />
                <v-card-subtitle v-if="!distributionsTotalIncome.isZero()">
                  Total: ${{ distributionsTotalIncomeFormatted }}
                </v-card-subtitle>
              </v-card>
            </v-card>
            <v-card flat>
              <v-textarea
                v-model="editedIncomeItem.comments"
                class="rounded-xl ma-2"
                auto-grow
                clearable
                counter="255"
                rows="2"
                outlined
                label="Comments (255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                :disabled="editedIncomeItem.frozen"
              />
              <span v-if="distributionsTotalIncome">
                Applied Exchange Rate: {{ appliedExchangeRateFormatted }}
              </span>
            </v-card>
            <div
              class="d-flex flex-row flex-wrap justify-space-around"
              style="width: 100%"
            >
              <div>
                <v-btn 
                  class="mt-4"
                  @click="closeEditIncome()"
                >
                  Cancel
                </v-btn>
              </div>
              <div>
                <v-btn 
                  class="mt-4"
                  :loading="loadingButton"
                  :disabled="editedIncomeItem.frozen"
                  @click="saveIncome()"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-form>
        <v-card-subtitle>{{ editedIncomeItem.id }}</v-card-subtitle>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_add_distributionIncome"
      :retain-focus="false"
      max-width="320px"
    >
      <v-card>
        <v-card-title class="d-flex flex-row flex-wrap py-0">
          <span>Distribute $</span>
          <span>
            <v-text-field
              v-model="amountDistributedIncome"
              class="pa-0 mx-2 mt-6"
              style="width: 80px"
              @change="calcDistributed()"
            />
          </span>
          <!-- <span>of {{ editedIncomeItem.currency }} {{ editedIncomeItem.amount }} to:</span> -->
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-list rounded>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(app, i) in selectApplicationsPayerItems"
                :key="i"
                @click="addDistributionIncome(app)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="app.appTitle" />
                  <v-list-item-subtitle v-text="app.id" />
                  <span v-if="app.totalPrice && app.amountPaidApplication"><v-list-item-content v-text="'Price $' + decUtil.format(app.totalPrice) + ' - Open $' + decUtil.format(decUtil.format(app.totalPrice) - decUtil.format(app.amountPaidApplication))" /></span>
                  <span v-else-if="app.totalPrice"><v-list-item-content v-text="'Open $' + decUtil.format(app.totalPrice)" /></span>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialog_add_distributionIncome = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        
    <v-dialog
      v-model="dialogIncomeDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title v-if="!editedIncomeItem.idSquare">
          Are you sure you want to delete the income payment of {{ editedIncomeItem.payerName }}?
        </v-card-title>
        <v-card-title v-else>
          Are you sure you want to remove the Quadrado?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="closeDeleteIncome"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            :loading="loadingButton"
            @click="deleteIncomeConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEditOutgoing"
      max-width="900px"
      persistent
    >
      <v-card
        :key="renderDialog"
        flat
        class="d-flex flex-column"
      >
        <v-card-title class="blue darken-1 white--text">
        
          <div v-if="editingOutgoing">
            Edit Outgoing
          </div>
          <div v-else>
            Add Outgoing
          </div>
          
        </v-card-title>
        <v-form
          ref="formOutgoing"
          flat
          class="d-flex flex-column pa-5"
        >
          <v-card-actions
            class="d-flex flex-column"
            style="width: 100%"
          >
            <v-card flat>
              <v-menu
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate(editedOutgoingsItem.dateTime)"
                    v-bind="attrs"
                    color="blue"
                    prepend-icon="$vuetify.icons.icon_mdi_calendar"
                    readonly
                    :disabled="editedOutgoingsItem.frozen"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="editedOutgoingsItem.dateTime"
                  color="blue"
                  no-title
                  scrollable
                  :max="nowDate"
                  :min="financialFirstOpenDay"
                  :disabled="editedOutgoingsItem.frozen"
                />
              </v-menu>
            </v-card>
            <v-card flat>
              <v-select
                v-model="editedOutgoingsItem.type_id"
                style="width: 400px"
                :items="selectTypesOutgoings(editedOutgoingsItem.type_id)"
                item-text="name"
                item-value="id"
                :menu-props="{ auto: true }"
                label="type of outgoing"
                single-line
                prepend-icon="mdi-arrow-right-thick blue--text"
                validate-on-blur
                class="mr-4"
                color="blue"
                item-color="blue"
                :rules="inputRulesReq"
                :disabled="distributionsOutgoingsNew.length > 0 || tabGeneral === 1 || editedOutgoingsItem.frozen"
                @change="changeOutgoingType()"
              />
            </v-card>
            <v-card
              flat
              :disabled="distributionsOutgoingsNew.length > 0 || tabGeneral === 1 || editedOutgoingsItem.frozen"
            >
              <v-select
                v-model="editedOutgoingsItem.client_id"
                style="width: 350px"
                :items="selectClients"
                item-text="full_name"
                item-value="id"
                :menu-props="{ auto: true }"
                v-if="editedOutgoingsItem.type_id && editedOutgoingsItem.receiver === 'Client' && !editedOutgoingsItem.frozen"
                label="client"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_account blue--text"
                validate-on-blur
                clearable
                class="mr-4"
                color="blue"
                item-color="blue"
                @change="chooseReceiver('client')"
              />
              <v-select
                v-model="editedOutgoingsItem.contact_id"
                style="width: 350px"
                :items="selectContactsOutgoings"
                item-text="full_name"
                item-value="id"
                :menu-props="{ auto: true }"
                v-if="editedOutgoingsItem.type_id && (editedOutgoingsItem.receiver === 'Contact' || editedOutgoingsItem.receiver === 'Contact Teacher' || editedOutgoingsItem.receiver === 'Contact Staff' || editedOutgoingsItem.receiver === 'Contact Accommodation') && !editedOutgoingsItem.frozen"
                label="contact"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_account_group blue--text"
                validate-on-blur
                clearable
                class="mr-4"
                color="blue"
                item-color="blue"
                @change="chooseReceiver('contact')"
              />
              <v-select
                v-model="editedOutgoingsItem.organisation_id"
                style="width: 350px"
                :items="selectContactsOutgoings"
                item-text="full_name"
                item-value="id"
                :menu-props="{ auto: true }"
                v-if="editedOutgoingsItem.type_id && (editedOutgoingsItem.receiver === 'Organisation Tour Agency' || editedOutgoingsItem.receiver === 'Organisation Project') && !editedOutgoingsItem.frozen"
                label="organisation"
                single-line
                prepend-icon="$vuetify.icons.icon_mdi_account_group blue--text"
                validate-on-blur
                clearable
                class="mr-4"
                color="blue"
                item-color="blue"
                @change="chooseReceiver('organisation')"
              />
              <div style="width: 350px">
                <v-text-field
                  v-model="editedOutgoingsItem.application_id"
                  v-if="editedOutgoingsItem.type_id && editedOutgoingsItem.receiver === 'Application' && !editedOutgoingsItem.frozen"
                  style="width: 250px"
                  label="application nr"
                  single-line
                  validate-on-blur
                  clearable
                  class="mr-4"
                  color="blue"
                  item-color="blue"
                  @change="checkAppNr()"
                />
                <span class="smallText">{{ editedOutgoingsItem.application_appTitle }}</span>
              </div>
            </v-card>
            <v-card
              v-if="editedOutgoingsItem.accountable === 1"
              flat
              class="d-flex flex-row flex wrap mb-8"
            >
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="editedOutgoingsItem.type_id !== 12 && editedOutgoingsItem.type_id !== 13 && editedOutgoingsItem.type_id !== 32"
                    color="ppc_pink"
                    dark
                    x-small
                    bottom
                    fab
                    :disabled="editedOutgoingsItem.frozen"
                    @click="openAddDistributionsOutgoings"
                    v-on="on"
                  >
                    <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                  </v-btn>
                </template>
                <span>add distribution</span>
              </v-tooltip>
              <v-card
                flat
                class="d-flex flex-column"
              >
                <v-data-table
                  v-if="editedOutgoingsItem.type_id !== 12 && editedOutgoingsItem.type_id !== 13 && editedOutgoingsItem.type_id !== 32"
                  :headers="headersDistributionsOutgoings"
                  :items="distributionsOutgoingsNew"
                  class="ma-4"
                  disable-pagination
                  hide-default-footer
                  dense
                >
                  <template v-slot:[`item.payment`]="{ item }">
                    <span v-if="hasMoney(item.payment)">
                      {{ item.currencyResource }} {{ formatMoney(item.payment) }}
                    </span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span v-if="hasMoney(item.amount)">
                      {{ item.currencyResource }} {{ formatMoney(item.amount) }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      :disabled="editedOutgoingsItem.type_id === 12 || editedOutgoingsItem.type_id === 13 || editedOutgoingsItem.type_id === 32 || editedOutgoingsItem.frozen"
                      @click="deleteDistributionOutgoing(item)"
                    >
                      $vuetify.icons.icon_mdi_delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-data-table
                  v-if="editedOutgoingsItem.type_id === 12 || editedOutgoingsItem.type_id === 13 || editedOutgoingsItem.type_id === 32"
                  :headers="headersClassesPayment"
                  :items="classesPayment"
                  class="ma-4"
                  disable-pagination
                  hide-default-footer
                  dense
                >
                  <template v-slot:[`item.start`]="{ item }">
                    {{ formattedDate(item.start, 'date') }}
                  </template>
                  <template v-slot:[`item.payment`]="{ item }">
                    <span v-if="hasMoney(item.paymentClass)">
                      S/. {{ formatMoney(item.paymentClass) }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      :disabled="loadingApp === 1 || classesPayment.length === 1"
                      @click="deleteClassesPayment(item)"
                    >
                      $vuetify.icons.icon_mdi_delete
                    </v-icon>
                  </template>
                </v-data-table>
                <span v-if="(editedOutgoingsItem.type_id === 12 || editedOutgoingsItem.type_id === 13 || editedOutgoingsItem.type_id === 32)">

                  Total: {{ classesPaymentTotal }}

                  <span v-if="discountPaymentTeachers">
                    - {{ discountFormatted }}
                    (AFP {{ editedOutgoingsItem.discount_payment_teacher }}%)
                  </span>

                  <span v-if="hasCorrection">

                    <span v-if="correctionIsPositive">+ </span>
                    {{ correctionFormatted }}
                    ({{ editedOutgoingsItem.comments_correction }})

                  </span>
                </span>
              </v-card>
            </v-card>
            <v-card-subtitle style="width: 100%">
              <v-divider />
            </v-card-subtitle>
            <v-select
              v-model="editedOutgoingsItem.paymentMethod"
              style="width: 250px"
              :items="selectPaymentMethods()"
              item-text="method"
              item-value="id"
              :menu-props="{ auto: true }"
              v-if="tabGeneral === 1 || tabGeneral === 2"
              label="payment method"
              single-line
              prepend-icon="$vuetify.icons.icon_mdi_credit_card_outline blue--text"
              validate-on-blur
              clearable
              color="blue"
              item-color="blue"
              class="mr-4"
              :rules="inputRulesReq"
              :disabled="editedOutgoingsItem.fixedPaymentMethod === 1 || editedOutgoingsItem.frozen"
            />
            <v-card
              flat
              class="d-flex flex-row flex-wrap"
            >
              <span class="text-h6 mt-8 mr-4">Payment:</span>
              <v-radio-group
                v-if="editedOutgoingsItem.type_id !== 12 && editedOutgoingsItem.type_id !== 13 && editedOutgoingsItem.type_id !== 32"
                v-model="editedOutgoingsItem.currency"
                :rules="inputRulesReq"
                class="mt-4"
                :disabled="editedOutgoingsItem.type_id === 12 || editedOutgoingsItem.type_id === 13 || editedOutgoingsItem.type_id === 32 || editedOutgoingsItem.frozen"
              >
                <v-radio
                  v-if="editedOutgoingsItem.type_id !== 73"
                  label="USD"
                  value="$"
                  color="blue"
                />
                <v-radio
                  v-if="editedOutgoingsItem.type_id !== 72 && editedOutgoingsItem.type_id !== 73 && editedOutgoingsItem.type_id !== 74 && editedOutgoingsItem.type_id !== 63"
                  label="PEN"
                  value="S/."
                  color="blue"
                />
                <v-radio
                  v-if="editedOutgoingsItem.type_id === 73 || editedOutgoingsItem.type_id === 57 || editedOutgoingsItem.type_id === 50"
                  label="EUR"
                  value="€"
                  color="blue"
                />
                <v-radio
                  v-if="editedOutgoingsItem.type_id === 73 || editedOutgoingsItem.type_id === 57"
                  label="GBP"
                  value="£"
                  color="blue"
                />
              </v-radio-group>
              <v-card
                flat
                class="ma-2 mt-4 pa-4 rounded-xl"
                width="120px"
              >
                <v-text-field
                  v-if="editedOutgoingsItem.accountable === 0"
                  v-model="editedOutgoingsItem.amount"
                  class="pa-0 mr-2"
                  label="amount paid"
                  :rules="numberRule"
                  color="blue"
                  :disabled="editedOutgoingsItem.frozen"
                />
                <span v-if="(editedOutgoingsItem.type_id === 12 || editedOutgoingsItem.type_id === 13 || editedOutgoingsItem.type_id === 32) && distributionsTotalOutgoingsDollar && (discountPaymentTeachers || editedOutgoingsItem.correction)">
                  <span>S/.{{ totalOutgoingsSolesFinal }}</span>
                </span>
                <span v-else-if="editedOutgoingsItem.currency === '$' && editedOutgoingsItem.accountable === 1">
                  ${{ distributionsTotalOutgoingsDollarFormatted }}
                </span>
                <span v-else-if="editedOutgoingsItem.currency === &quot;S/.&quot; && editedOutgoingsItem.accountable === 1">
                  S/.{{ distributionsTotalOutgoingsSolesFormatted }}
                </span>
              </v-card>
              <v-card
                v-if="tabGeneral === 1 || tabGeneral === 2"
                flat
                class="ma-2 pa-4 rounded-xl"
              >
                <v-text-field
                  v-model="editedOutgoingsItem.bankTransferFee"
                  class="pa-0 mr-2"
                  label="bank transfer fee"
                  clearable
                  color="blue"
                  :disabled="editedOutgoingsItem.frozen"
                />
              </v-card>
            </v-card>
            <v-card flat>
              <v-textarea
                v-model="editedOutgoingsItem.comments"
                class="rounded-xl ma-2"
                auto-grow
                clearable
                counter="255"
                rows="2"
                outlined
                color="blue"
                label="Comments (255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                :disabled="editedOutgoingsItem.frozen"
              />
            </v-card>
            <v-card-subtitle style="width: 100%">
              <v-divider />
            </v-card-subtitle>
            <div
              class="d-flex flex-row flex-wrap justify-space-around"
              style="width: 100%"
            >
              <div>
                <v-btn 
                  class="mt-4"
                  @click="closeEditOutgoing()"
                >
                  Cancel
                </v-btn>
              </div>
              <div>
                <v-btn 
                  class="mt-4"
                  :loading="loadingButton"
                  :disabled="(editedOutgoingsItem.receiver === 'Application' && editedOutgoingsItem.application_appTitle === '') || editedOutgoingsItem.frozen"
                  @click="saveOutgoing()"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-form>
        <v-card-subtitle>{{ editedOutgoingsItem.id }}</v-card-subtitle>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogOutgoingDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title
          v-if="!editedOutgoingsItem.idSquare"
          class="blue--text"
        >
          Are you sure you want to delete the Outgoing payment of {{ editedOutgoingsItem.receiverName }}?
        </v-card-title>
        <v-card-title
          v-else
          class="blue--text"
        >
          Are you sure you want to remove the Quadrado?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDeleteOutgoing"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingButton"
            @click="deleteOutgoingConfirm()"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_add_distributionOutgoings"
      :retain-focus="false"
      max-width="320px"
    >
      <v-card>
        <v-card-title class="d-flex flex-row flex-wrap py-0">
          <span>Distribute</span>
          <span>
            <v-text-field
              v-model="amountDistributedOutgoings"
              class="pa-0 mx-2 mt-6"
              style="width: 40px"
            />
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-list rounded>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(resource, i) in selectResourceReceiverItems"
                :key="i"
                :disabled="!amountDistributedOutgoings || amountDistributedOutgoings === null || amountDistributedOutgoings === 0"
                @click="addDistributionOutgoings(resource)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="resource.resourceName" />
                  <v-list-item-subtitle v-text="resource.full_name" />
                  <v-list-item-subtitle
                    v-if="resource.first_class"
                    v-text="'First class: ' + formattedDate(resource.first_class, 'dateAndTime')"
                  />
                  <span v-if="paymentStatusText(resource)">
                    <v-list-item-content
                      :text="paymentStatusText(resource)"
                    />
                  </span>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialog_add_distributionOutgoings = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Transaction Dialogs -->
        
    <v-dialog
      v-model="dialogTransactionIncome"
      max-width="900px"
    >
      <v-card
        :key="renderDialog"
        flat
        class="d-flex flex-column"
      >
        <v-card-title class="py-6 ppc_darkgreen darken-1 white--text">
          Transaction Income
        </v-card-title>
        <v-card-subtitle
          v-if="hasTransactionIncome"
          class="ppc_darkgreen flex-row flex-wrap darken-1 white--text"
        >
          Payer: {{ transactionHeader.payer }}
          – Price: ${{ transactionHeader.totalFormatted }}
          – Paid ${{ transactionHeader.paidFormatted }}

          <span v-if="transactionHeader.transferFeeIncluded">
            – Transfer Fees Included
          </span>

          <v-spacer />

          TransNr: {{ transactionHeader.id }}

          <span v-if="transactionHeader.isOpen">– Open</span>
          <span v-if="transactionHeader.isClosed">– Closed</span>
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="headersDistributionsTransactionIncome"
            :items="distributionsIncomeTable"
            class="clickable-table ma-2"
            disable-pagination
            hide-default-footer
            dense
            :search="searchTransactionIncomeTable"
            @click:row="openEditIncome($event)"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchTransactionIncomeTable"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ distributionsIncomeTable.length }` + ' transactions(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.amountIncome`]="{ item }">
              <span>{{ item.currencyIncome }} {{ item.amountIncome }}</span>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <span>$ {{ item.amount }}</span>
            </template>
            <template v-slot:[`item.paidOn`]="{ item }">
              <span v-html="formattedDate(item.paidOn)" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions
          class="d-flex flex-row"
          style="width: 100%"
        >
          <v-spacer />
          <div>
            <v-btn 
              class="mt-4"
              @click="dialogTransactionIncome = false;"
            >
              Ok
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogTransactionOutgoings"
      max-width="900px"
    >
      <v-card
        :key="renderDialog"
        flat
        class="d-flex flex-column"
      >
        <v-card-title class="py-6 blue darken-1 white--text">
          Transaction Outgoings
        </v-card-title>
        <v-card-subtitle
          v-if="hasTransactionOutgoing"
          class="d-flex flex-row flex-wrap blue darken-1 white--text"
        >
          Receiver: {{ transactionOutgoingHeader.receiver }}
          – Costs: ${{ transactionOutgoingHeader.costsDollarsFormatted }}
          + S/.{{ transactionOutgoingHeader.costsSolesFormatted }}
          – Paid ${{ transactionOutgoingHeader.paidDollarsFormatted }}
          (S/.{{ transactionOutgoingHeader.paidSolesFormatted }})

          <v-spacer />

          TransNr: {{ transactionOutgoingHeader.id }}

          <span v-if="transactionOutgoingHeader.isOpen">– Open</span>
          <span v-if="transactionOutgoingHeader.isClosed">– Closed</span>
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="headersDistributionsTransactionOutgoings"
            :items="distributionsOutgoingsTable"
            class="clickable-table ma-2"
            disable-pagination
            hide-default-footer
            dense
            sort-by="paidOn"
            :search="searchTransactionOutgoingsTable"
            @click:row="openEditOutgoings($event)"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchTransactionOutgoingsTable"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ distributionsOutgoingsTable.length }` + ' transactions(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ item.currency }}
              <span v-if="item.currency === 'S/.'"> {{ decUtil.format(decUtil.toDec(item.amount),0) }}</span>
              <span v-else> {{ decUtil.format(decUtil.toDec(item.amount)) }}</span>
            </template>
            <template v-slot:[`item.paidOn`]="{ item }">
              <span v-html="formattedDate(item.paidOn)" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions
          class="d-flex flex-row"
          style="width: 100%"
        >
          <v-spacer />
          <div>
            <v-btn 
              class="mt-4"
              @click="dialogTransactionOutgoings = false;"
            >
              Ok
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogValutaYear"
      max-width="800px"
      scrollable
    >
      <v-card
        height="80vh"
      >
        <div class="d-flex flex-row justify-space-between">
          <v-btn 
            :disabled="tabMonth === 0"
            class="ma-4"
            @click="switchMonthDialogValutaYear('down')"
          >
            <v-icon
              start
              small
            >
              mdi-arrow-left
            </v-icon>
            {{ itemsTabMonths[tabMonth-1] }}
          </v-btn>
          <v-card-title>{{ dialogValutaYearTitle }} {{ itemsTabMonths[tabMonth] }}</v-card-title>
          <v-btn 
            :disabled="tabMonth === 11"
            class="ma-4"
            @click="switchMonthDialogValutaYear('up')"
          >
            {{ itemsTabMonths[tabMonth+1] }}
            <v-icon
              end
              small
            >
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-data-table
            :headers="headersValutaMonths"
            :items="valutaMonth"
            class="elevation-1 ma-2"
            disable-pagination
            hide-default-footer
            dense
          >
            <template v-slot:[`item.amount`]="{ item }">
              <span v-if="item.amount">{{ decUtil.format(item.amount) }}</span>
            </template>
            <template v-slot:[`item.bankTransferFee`]="{ item }">
              <span v-if="item.bankTransferFee">{{ decUtil.format(item.bankTransferFee) }}</span>
            </template>
            <template v-slot:[`item.balance`]="{ item }">
              <span v-if="item.balance">{{ decUtil.format(item.balance) }}</span>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <span v-if="item.move==='IN' && item.amount">
                {{ decUtil.format(decUtil.toDec(item.amount)) }}
              </span>
              <span v-else-if="item.amount && item.bankTransferFee">
                {{ decUtil.format(
                  decUtil.toDec(item.amount).plus(decUtil.toDec(item.bankTransferFee))
                ) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSecurityDeposits"
      max-width="800px"
      scrollable
    >
      <v-card
        height="80vh"
      >
        <v-card-title>Oustanding Security Deposits</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersSecurityDeposits"
            :items="outstandingDeposits"
            class="elevation-1 ma-2"
            disable-pagination
            hide-default-footer
            dense
          >
            <template v-slot:[`item.clientName`]="{ item }">
              <v-btn
                small
                rounded
                @click="goClient(item.client_id)"
              >
                {{ item.clientName }}
              </v-btn>
            </template>
            <template v-slot:[`item.totals`]="{ item }">
              <span v-if="hasMoney(item.totals)">
                {{ formatMoney(item.totals) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogForm"
      :retain-focus="false"
      width="fit-content"
    >
      <div class="d-flex justify-space-around">
        <v-card 
          flat
          class="d-flex flex-column pa-12"
          width="210mm"
          min-height="297mm"
        >
          <span
            class="ma-2"
            v-html="outputData.formHTML"
          />
          <div class="d-flex flex-column invoiceButtons">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="ppc_pink"
                  fab
                  class="white--text my-2"
                  small
                  @click="dialogForm = false"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>close</span>
            </v-tooltip>
                        
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="blue"
                  fab
                  class="white--text my-2"
                  small
                  @click="printNow(outputData.formHTML)"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>print/download</span>
            </v-tooltip>
          </div>
        </v-card>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>

    import dayjs from 'dayjs';
    import compare from '../mixins/compare';
    import inputRules from '../mixins/inputRules';
    import formattedDate from '../mixins/formattedDate';
    import { print } from 'html-to-printer';
    import decUtil from '@/utils/decimalUtils';

    export default {

        mixins: [inputRules, formattedDate, compare],
        data: () => ({
            decUtil,
            nowDate: null,
            nowYear: null,
            cajaChicaDay: null,
            balanceGeneralYear: null,
            tabGeneral: 0,
            itemsTabGeneral: [
                'Caja Chica', 'Transactions', 
            ],
            tabCategoriesTypes: 0,
            tabTransactions: 0,
            tabMonth: 0,
            itemsTabMonths: [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ],
            tabIncomeOutgoing: 0,
            renderDialog: Math.random(),
            // renderTabMonth: Math.random(),
            renderTabCategoriesTypes: Math.random(),
            // Income
            dialogIncomeDelete: false,
            dialogEditIncome: false,
            dialogForm: false,
            loadingButton: false,
            selectClients: [],
            headersIncome: [
                { text: 'Payment', value: 'payment', width: "150px", align: 'right' },
                { text: 'Type', value: 'typeName' },
                { text: 'Payer Name', value: 'payerName' },
                { text: 'Comments', value: 'comments' },
                // { text: 'Dist', value: 'allDistributed' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            headersIncomeMonth: [
                {
                    text: 'Date',
                    align: 'start',
                    sortable: false,
                    value: 'date',
                    width:  '120px',
                },
                { text: 'Payment', value: 'payment', width: "150px", align: 'right' },
                { text: 'Category', value: 'categoryName' },
                { text: 'Type', value: 'typeName' },
                { text: 'Payer Name', value: 'payerName' },
                { text: 'Methods', value: 'paymentMethodName' },
                { text: 'Comments', value: 'comments' },
                // { text: 'Dist', value: 'allDistributed' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            incomeDay: [],
            editedIncomeIndex: -1,
            editedIncomeItem: {
                dateTime: null,
                date: null,
                application_id: null,
                type_id: null,
                client_id: null,
                agency_id: null,
                contact_id: null,
                paymentMethod: null,
                currency: '$',
                amount: null,
                bankTransferFee: null,
                exchangeRate: null,
                obsolete: null,
            },
            defaultIncomeItem: {
                dateTime: null,
                date: null,
                application_id: null,
                type_id: null,
                client_id: null,
                agency_id: null,
                contact_id: null,
                paymentMethod: null,
                currency: '$',
                amount: null,
                bankTransferFee: null,
                exchangeRate: null,
                obsolete: null,
            },
            // Outgoings
            dialogEditOutgoing: false,
            dialogOutgoingDelete: false,
            headersOutgoings: [
                { text: 'Payment', value: 'payment', width: "150px", align: 'right' },
                { text: 'Type', value: 'typeName' },
                { text: 'Receiver Name', value: 'receiverName' },
                { text: 'Comments', value: 'comments' },
                // { text: 'Dist', value: 'allDistributed' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            headersOutgoingsMonth: [
                {
                    text: 'Date',
                    align: 'start',
                    sortable: false,
                    value: 'date',
                    width:  '120px',
                },
                { text: 'Payment', value: 'payment', width: "150px", align: 'right' },
                { text: 'Category', value: 'categoryName' },
                { text: 'Type', value: 'typeName' },
                { text: 'Receiver Name', value: 'receiverName' },
                { text: 'Methods', value: 'paymentMethodName' },
                { text: 'Comments', value: 'comments' },
                // { text: 'Dist', value: 'allDistributed' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            outgoingsDay: [],
            editedOutgoingIndex: -1,
            editedOutgoingsItem: {
                dateTime: null,
                date: null,
                type_id: null,
                client_id: null,
                contact_id: null,
                paymentMethod: null,
                currency: 'S/.',
                amount: null,
                bankTransferFee: null,
                exchangeRate: null,
                obsolete: null,
                application_appTitle: '',
            },
            defaultOutgoingItem: {
                dateTime: null,
                date: null,
                type_id: null,
                client_id: null,
                contact_id: null,
                paymentMethod: null,
                currency: 'S/.',
                amount: null,
                bankTransferFee: null,
                exchangeRate: null,
                obsolete: null,
            },
            // Gategories Income
            headersCategoriesIncome: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
            ],
            categoriesIncome: [],
            editedCategoryIncomeIndex: -1,
            editedCategoryIncomeItem: {
                name: '',
                obsolete: null,
            },
            defaultCategoryIncome: {
                name: '',
                obsolete: null,
            },
            // Gategories Outgoings
            headersCategoriesOutgoings: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
            ],
            categoriesOutgoings: [],
            editedCategoryOutgoingsIndex: -1,
            editedCategoryOutgoingsItem: {
                name: '',
                obsolete: null,
            },
            defaultCategoryOutgoings: {
                name: '',
                obsolete: null,
            },
            // Types Income
            dialogTypeIncome: false,
            dialogTypeIncomeDelete: false,
            headersTypesIncome: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Category', value: 'categoryName' },
                { text: 'Payer', value: 'payer' },
                { text: 'Accountable', value: 'accountable' },
                { text: 'Payment Method Variable', value: 'paymentMethod' },
                { text: 'Caja Chica', value: 'showCajaChica' },
                { text: 'Fixed', value: 'fixed' },
                { text: 'Description', value: 'description' },
                { text: 'Used', value: 'used' },
                { text: 'Obsolete', value: 'obsolete' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            typesIncome: [],
            editedTypeIncomeIndex: -1,
            editedTypeIncomeItem: {
                name: '',
                category_id: null,
                paymentMethod: null,
                payer: 'No payer',
                accountable: 1,
                showCajaChica: 1,
                fixed: 0,
                decription: '',
                obsolete: null,
            },
            defaultTypeIncome: {
                name: '',
                category_id: null,
                paymentMethod: null,
                payer: 'No payer',
                accountable: 1,
                showCajaChica: 1,
                fixed: 0,
                decription: '',
                obsolete: null,
            },
            selectPayer: [
                {
                    name: 'No payer',
                    value: 'No payer',
                },
                {
                    name: 'PPC',
                    value: 'PPC',
                },
                {
                    name: 'Contact',
                    value: 'Contact',
                },
                {
                    name: 'Client',
                    value: 'Client',
                },
                {
                    name: 'Client Agency',
                    value: 'Client Agency',
                },
            ],
            // Types Outgoings
            dialogTypeOutgoings: false,
            dialogTypeOutgoingsDelete: false,
            headersTypesOutgoings: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Category', value: 'categoryName' },
                { text: 'Receiver', value: 'receiver' },
                { text: 'Accountable', value: 'accountable' },
                { text: 'Payment Method Variable', value: 'paymentMethod' },
                { text: 'Caja Chica', value: 'showCajaChica' },
                { text: 'Fixed', value: 'fixed' },
                { text: 'Description', value: 'description' },
                { text: 'Used', value: 'used' },
                { text: 'Obsolete', value: 'obsolete' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            typesOutgoings: [],
            editedTypeOutgoingsIndex: -1,
            editedTypeOutgoingsItem: {
                name: '',
                category_id: null,
                receiver: 'No receiver',
                contact_id: null,
                paymentMethod: 0,
                accountable: 1,
                showCajaChica: 1,
                fixed: 0,
                decription: '',
                obsolete: null,
            },
            defaultTypeOutgoings: {
                name: '',
                category_id: null,
                receiver: 'No receiver',
                contact_id: null,
                paymentMethod: 0,
                accountable: 1,
                showCajaChica: 1,
                fixed: 0,
                decription: '',
                obsolete: null,
            },
            selectReceiver: [
                {
                    name: 'No receiver',
                    value: 'No receiver',
                },
                {
                    name: 'PPC',
                    value: 'PPC',
                },
                {
                    name: 'Contact',
                    value: 'Contact',
                },
                {
                    name: 'Client',
                    value: 'Client',
                },
                {
                    name: 'Contact Staff',
                    value: 'Contact Staff',
                },
                {
                    name: 'Organisation',
                    value: 'Organisation',
                },
                {
                    name: 'Organisation Client Agency',
                    value: 'Organisation Client Agency',
                },
                {
                    name: 'Organisation Tour Agency',
                    value: 'Organisation Tour Agency',
                },
                {
                    name: 'Organisation Project',
                    value: 'Organisation Project',
                },
                {
                    name: 'Contact Accommodation',
                    value: 'Contact Accommodation',
                },
                {
                    name: 'Contact Teacher',
                    value: 'Contact Teacher',
                },
                {
                    name: 'Fixed Contact',
                    value: 'Fixed Contact',
                },
                {
                    name: 'Application',
                    value: 'Application',
                },
            ],
            incomeMonth: [],
            outgoingsMonth: [],
            currentBalances: [],
            dayIncomeSoles: 0,
            dayIncomeDollars: 0,
            dayOutgoingsSoles: 0,
            dayOutgoingsDollars: 0,
            lastSquareDateTime: 0,
            // filterBalanceGeneral: 'All',
            selectApplicationsPayer: [],
            selectResourceReceiver: [],
            selectResourceReceiverItems: [],
            dialogTransactionIncome: false,
            dialogTransactionOutgoings: false,
            transactionsIncome: [],
            transactionsOutgoings: [],
            headersTransactionsIncome: [
                { text: 'Payer Name', align: 'start', value: 'payerName' },
                { text: 'Price USD', value: 'totalPriceTransaction' },
                { text: 'Paid USD', value: 'amountPaidTransaction' },
                { text: 'Closed', value: 'transactionClosed' },
                { text: 'Last Change', value: 'id' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            headersTransactionsOutgoings: [
                { text: 'Receiver name', align: 'start', value: 'receiverName' },
                { text: 'Payment', value: 'totalPaymentTransactionSoles' },
                { text: 'Paid USD (PEN)', value: 'amountSoles' },
                { text: 'Closed', value: 'transactionClosed' },
                { text: 'Last Change', value: 'id' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            openDistributionsIncome: [],
            closedDistributionsIncome: [],
            distributionsTransactionsOutgoings: [],
            allDistributionsOutgoings: [],
            editedApplicationsDistributionIncome: [],
            transactionIncome: [],
            headersDistributionsTransactionIncome: [
                { text: 'Payment', value: 'paidOn' },
                { text: 'Method', value: 'paymentMethodName' },
                { text: 'Income', value: 'amountIncome' },
                { text: 'Transfer Fee', value: 'bankTransferFee' },
                { text: 'Distributed', value: 'amount' },
            ],
            transactionOutgoing: [],
            headersDistributionsTransactionOutgoings: [
                { text: 'Payment', value: 'paidOn', width: '150px' },
                { text: 'Resource', value: 'resourceName' },
                { text: 'Client', value: 'full_name' },
                { text: 'Receiver', value: 'receiverName' },
                { text: 'Method', value: 'paymentMethodName' },
                { text: 'Distributed', value: 'amount' }
            ],
            distributionsIncomeTable: [],
            distributionsIncomeOld: [],
            distributionsIncomeNew: [],
            headersDistributionsIncome: [
                { text: 'Application', value: 'appTitle' },
                { text: 'Price', value: 'totalPrice' },
                { text: 'Distributed', value: 'amount' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            distributionsOutgoingsTable: [],
            distributionsOutgoingsOld: [],
            distributionsOutgoingsNew: [],
            headersDistributionsOutgoings: [
                // { text: 'id', value: 'id' },
                // { text: 'resId', value: 'resource_id' },
                { text: 'Client', value: 'full_name' },
                { text: 'Payment', value: 'payment' },
                { text: 'Distributed', value: 'amount' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            headersClassesPayment: [
                { text: 'Class', value: 'start' },
                { text: 'Students', value: 'students_short' },
                { text: 'Language', value: 'class_language' },
                { text: 'Group', value: 'class_group' },
                { text: 'Type', value: 'class_type' },
                { text: 'Payment', value: 'payment' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            classesPayment: [],
            classesPaymentOld: [],
            dialog_add_distributionIncome: false,
            dialog_add_distributionOutgoings: false,
            amountDistributedIncome: null,
            amountDistributedOutgoings: null,
            transferFeeIncluded: 0,
            loadingbuttonLoadTransactionsOpen: false,
            loadingbuttonLoadTransactionsClosed: false,
            // totalSoles: null,
            // totalDollars: null,
            selectContactsOrganisations: [],
            loadingCajas: true,
            financialLocked: null,
            lockedFinancialMonth: null,
            financialFirstOpenDay: null,
            valutaYear: [],
            valutaMonth: [],
            dialogValutaYear: false,
            headersValutaMonths: [
                { text: 'Date', value: 'dateTime' },
                { text: 'Move', value: 'move' },
                { text: 'Amount', value: 'amount' },
                { text: 'Bank Transfer Fee', value: 'bankTransferFee', width: '50px' },
                { text: 'Total', value: 'total' },
                { text: 'Balance', value: 'balance' },
            ],
            dialogValutaYearTitle: '',
            outstandingDeposits: [],
            outstandingDepositsTotal: 0,
            dialogSecurityDeposits: false,
            headersSecurityDeposits: [
                { text: 'Client', value: 'clientName' },
                { text: 'Outstanding', value: 'totals' },
            ],
            outputData: {},
            hideTotals: [],
            rateEUR: null,
            rateGBP: null,
            searchTransactionIncomeTable: '',
            searchTransactionOutgoingsTable: '',
            noRates: false,
            editingOutgoing: false,
            editingIncome: false,
        }),

        computed: {

            loadingApp () {
                return this.$store.getters.loadingApp
            },
            formTitleTypeIncome () {
                return this.editedCategoryIncomeIndex === -1 ? 'New Income Type' : 'Edit Income Type'
            },
            formTitleTypeOutgoings () {
                return this.editedCategoryOutgoingsIndex === -1 ? 'New Outgoings Type' : 'Edit Outgoings Type'
            },
            selectCategoriesIncome () {
                return this.categoriesIncome.filter(function(select_item) {
                    return select_item.obsolete === null;
                })
            },
            selectCategoriesOutgoings () {
                return this.categoriesOutgoings.filter(function(select_item) {
                    return select_item.obsolete === null;
                })
            },
            computedDateFormatted () {
                return this.formattedDate(this.cajaChicaDay)
            },
            distributionsTotalOutgoingsDollar() {
                const exchangeRate = this.decUtil.toDec(this.$store.state.exchangeRate);

                const total = this.distributionsOutgoingsNew.reduce((sum, item) => {
                    const amount = this.decUtil.toDec(item.amount);

                    return item.currencyResource === '$'
                    ? sum.plus(amount)
                    : sum.plus(amount.div(exchangeRate));
                }, this.decUtil.toDec(0));

                return this.decUtil.format(total);
            },

            distributionsTotalOutgoingsSoles() {
                const exchangeRate = this.decUtil.toDec(this.$store.state.exchangeRate);

                // console.log("distributionsTotalOutgoingsSoles",this.distributionsOutgoingsNew);

                const total = this.distributionsOutgoingsNew.reduce((sum, item) => {
                    const amount = this.decUtil.toDec(item.amount);

                    return item.currencyResource === '$'
                      ? sum.plus(amount.times(exchangeRate))
                      : sum.plus(amount);
                }, this.decUtil.toDec(0));

                // console.log("distributionsTotalOutgoingsSoles #2",this.distributionsOutgoingsNew, this.decUtil.format(total));

                return this.decUtil.format(total);
            },

            discountPaymentTeachers() {
                const discountPercent = this.decUtil.toDec(
                    this.editedOutgoingsItem.discount_payment_teacher
                );

                const total = this.decUtil.toDec(this.distributionsTotalOutgoingsSoles);

                return this.decUtil.format(
                    total.times(discountPercent).div(100)
                );
            },
            
            discountFormatted() {
                return this.decUtil.format(this.discountPaymentTeachers);
            },

            hasCorrection() {
                return (
                this.editedOutgoingsItem.correction !== null &&
                this.editedOutgoingsItem.correction !== undefined &&
                !this.decUtil.toDec(this.editedOutgoingsItem.correction).isZero()
                );
            },

            correctionDec() {
                return this.decUtil.toDec(this.editedOutgoingsItem.correction);
            },

            correctionFormatted() {
                return this.decUtil.format(this.correctionDec);
            },

            correctionIsPositive() {
                return this.correctionDec.gt(0);
            },

            appliedExchangeRateFormatted() {
                // guard: missing data
                if (
                    this.distributionsTotalIncome === null ||
                    this.editedIncomeItem.amount === null
                ) {
                    return '0.00';
                }

                const amount = this.decUtil.toDec(this.editedIncomeItem.amount);
                const bankTransferFee = this.decUtil.toDec(this.editedIncomeItem.bankTransferFee);
                const distributionsTotalIncome = this.decUtil.toDec(this.distributionsTotalIncome);

                // guard: division by zero
                if (amount.isZero() ||distributionsTotalIncome.isZero()) {
                    return '0.00';
                }

                return this.decUtil.format(
                    this.decUtil
                    .toDec(amount)
                    .plus(bankTransferFee)
                    .div(distributionsTotalIncome)
                );
            },

            distributionsTotalIncome() {
                return this.distributionsIncomeNew.reduce(
                    (sum, item) => sum.plus(item.amount),
                    this.decUtil.toDec(0)
                );
            },

            distributionsTotalIncomeFormatted() {
                return this.decUtil.format(this.distributionsTotalIncome);
            },

            distributionsTotalOutgoingsDollarFormatted() {
                return this.decUtil.format(this.distributionsTotalOutgoingsDollar);
            },

            distributionsTotalOutgoingsSolesFormatted() {
                return this.decUtil.format(this.distributionsTotalOutgoingsSoles);
            },

            cashSolesFormatted() {
                const val = this.currentBalances[1];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            cashDollarsFormatted() {
                const val = this.currentBalances[0];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            hasCashSoles() {
                return (
                    this.currentBalances[1] !== null &&
                    this.currentBalances[1] !== undefined &&
                    !this.decUtil.toDec(this.currentBalances[1]).isZero()
                );
            },

            hasCashDollars() {
                return (
                    this.currentBalances[0] !== null &&
                    this.currentBalances[0] !== undefined &&
                    !this.decUtil.toDec(this.currentBalances[0]).isZero()
                );
            },

            bankSolesFormatted() {
                const val = this.currentBalances[3];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            bankDollarsFormatted() {
                const val = this.currentBalances[2];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            hasBankSoles() {
                return (
                    this.currentBalances[3] !== null &&
                    this.currentBalances[3] !== undefined &&
                    !this.decUtil.toDec(this.currentBalances[3]).isZero()
                );
            },

            hasBankDollars() {
                return (
                    this.currentBalances[2] !== null &&
                    this.currentBalances[2] !== undefined &&
                    !this.decUtil.toDec(this.currentBalances[2]).isZero()
                );
            },

            wiseDollarsFormatted() {
                const val = this.currentBalances[2];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            wiseEurosFormatted() {
                const val = this.currentBalances[3];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            wiseGbpFormatted() {
                const val = this.currentBalances[4];
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            hasWiseDollars() {
                return (
                this.currentBalances[2] !== null &&
                this.currentBalances[2] !== undefined &&
                !this.decUtil.toDec(this.currentBalances[2]).isZero()
                );
            },

            hasWiseEuros() {
                return (
                this.currentBalances[3] !== null &&
                this.currentBalances[3] !== undefined &&
                !this.decUtil.toDec(this.currentBalances[3]).isZero()
                );
            },

            hasWiseGbp() {
                return (
                this.currentBalances[4] !== null &&
                this.currentBalances[4] !== undefined &&
                !this.decUtil.toDec(this.currentBalances[4]).isZero()
                );
            },

            dayIncomeDollarsFormatted() {
                if (this.dayIncomeDollars === null || this.dayIncomeDollars === undefined) {
                    return null;
                }
                return this.decUtil.format(this.dayIncomeDollars);
            },

            dayIncomeSolesFormatted() {
                if (this.dayIncomeSoles === null || this.dayIncomeSoles === undefined) {
                    return null;
                }
                return this.decUtil.format(this.dayIncomeSoles);
            },

            hasDayIncomeDollars() {
                return (
                this.dayIncomeDollars !== null &&
                this.dayIncomeDollars !== undefined &&
                !this.decUtil.toDec(this.dayIncomeDollars).isZero()
                );
            },

            hasDayIncomeSoles() {
                return (
                this.dayIncomeSoles !== null &&
                this.dayIncomeSoles !== undefined &&
                !this.decUtil.toDec(this.dayIncomeSoles).isZero()
                );
            },

            outstandingDepositsTotalFormatted() {
                if (
                this.outstandingDepositsTotal === null ||
                this.outstandingDepositsTotal === undefined
                ) {
                return null;
                }
                return this.decUtil.format(this.outstandingDepositsTotal);
            },

            hasOutstandingDepositsTotal() {
                return (
                this.outstandingDepositsTotal !== null &&
                this.outstandingDepositsTotal !== undefined &&
                !this.decUtil.toDec(this.outstandingDepositsTotal).isZero()
                );
            },

            hasTransactionIncome() {
                return this.transactionIncome.length > 0;
            },

            transactionHeader() {
                if (!this.hasTransactionIncome) return null;

                const t = this.transactionIncome[0];

                return {
                payer: t.payerName,
                totalFormatted: this.decUtil.format(t.totalPriceTransaction),
                paidFormatted: this.decUtil.format(t.amountPaidTransaction),
                transferFeeIncluded: t.transferFeeIncluded === 1,
                id: t.id,
                isOpen: t.transactionClosed === 0,
                isClosed: t.transactionClosed === 1
                };
            },

            hasTransactionOutgoing() {
                return this.transactionOutgoing.length > 0;
            },

            transactionOutgoingHeader() {
                if (!this.hasTransactionOutgoing) return null;

                const t = this.transactionOutgoing[0];

                return {
                receiver: t.receiverName,
                costsDollarsFormatted: this.decUtil.format(
                    t.totalPaymentTransactionDollars
                ),
                costsSolesFormatted: this.decUtil.format(
                    t.totalPaymentTransactionSoles
                ),
                paidDollarsFormatted: this.decUtil.format(t.amountDollars),
                paidSolesFormatted: this.decUtil.format(t.amountSoles),
                id: t.id,
                isOpen: t.transactionClosed === 0,
                isClosed: t.transactionClosed === 1
                };
            },

            totalOutgoingsSolesFinal() {
                return this.decUtil.format(
                    this.decUtil
                    .toDec(this.classesPaymentTotal)
                    .minus(this.discountPaymentTeachers)
                    .plus(this.editedOutgoingsItem.correction)
                );
            },

            dayOutgoingsDollarsFormatted() {
                if (this.dayOutgoingsDollars === null || this.dayOutgoingsDollars === undefined) {
                return null;
                }
                return this.decUtil.format(this.dayOutgoingsDollars);
            },

            dayOutgoingsSolesFormatted() {
                if (this.dayOutgoingsSoles === null || this.dayOutgoingsSoles === undefined) {
                return null;
                }
                return this.decUtil.format(this.dayOutgoingsSoles);
            },

            hasDayOutgoingsDollars() {
                return (
                this.dayOutgoingsDollars !== null &&
                this.dayOutgoingsDollars !== undefined &&
                !this.decUtil.toDec(this.dayOutgoingsDollars).isZero()
                );
            },

            hasDayOutgoingsSoles() {
                return (
                this.dayOutgoingsSoles !== null &&
                this.dayOutgoingsSoles !== undefined &&
                !this.decUtil.toDec(this.dayOutgoingsSoles).isZero()
                );
            },

            selectApplicationsPayerItems() {
                console.log('selectApplicationsPayerItems', this.selectApplicationsPayer);
                return this.selectApplicationsPayer.filter(app => {
                    const paid = this.decUtil.toDec(app.amountPaidApplication ?? 0);

                    const alreadyDistributed = this.distributionsIncomeNew
                        .some(e => e.application_id === app.id);

                    const total = this.decUtil.toDec(app.totalPrice ?? 0);

                    const remaining = total.minus(paid).abs();

                    return !alreadyDistributed && remaining.gt(0.01);
                });
            },

            equalInDollars() {

                const currency = this.editedIncomeItem.currency;
                const amount = this.editedIncomeItem.amount;

                const a = this.decUtil.toDec(amount);
                let usd;

                if (currency === 'S/.') {
                    // PEN → USD
                    usd = a.div(this.$store.state.exchangeRate);
                } else if (currency === '€') {
                    // EUR → USD
                    usd = a.div(this.rateEUR);
                } else if (currency === '£') {
                    // GBP → USD
                    usd = a.div(this.rateGBP);
                } else {
                    // already USD or unsupported currency
                    usd = a;
                }

                // IO boundary → format once
                return this.decUtil.format(usd);
            },

            selectContactsOutgoings () {
                const receiver = this.editedOutgoingsItem.receiver;

                if (receiver === 'Contact Accommodation') {
                    return this.$store.state.contacts.filter(c =>
                        c.obsolete === null && c.accommodation > 0
                    );
                }

                if (
                    receiver === 'Organisation Tour Agency' ||
                    receiver === 'Organisation Project'
                ) {
                    return this.selectContactsOrganisations;
                }

                if (receiver === 'Contact Teacher') {
                    return this.$store.state.activeTeachers.map(t => ({
                        id: t.contact_id,
                        full_name: t.contactFullName,
                    }));
                }

                if (receiver === 'Contact Staff') {
                    return this.$store.state.contacts.filter(c =>
                        c.obsolete === null && c.staff > 0
                    );
                }

                return this.$store.state.contacts.filter(c =>
                    c.obsolete === null
                );
            },

            classesPaymentTotal() {
                return this.decUtil.format(this.classesPayment.reduce((total, cls) => {
                    return total.plus(
                        this.decUtil.toDec(cls.paymentClass || 0)
                    );
                }, this.decUtil.toDec(0)));
            },
            
        },

        mounted() {
            let breadcrumb = [];
            breadcrumb.push('Financial')
            this.$store.dispatch('breadcrumbs', breadcrumb);
        },

        beforeCreate () {
            if (this.$store.state.accessFinancial === 0) {
                this.$router.push({ name: 'Illegal' })
            }
        },

        created () {
            dayjs.locale("en");
            this.$store.dispatch('setLoadingApp', 1)
            this.initialize();
        },

        methods: {

            async initialize () {
                console.log('Financial initialize');
                
                this.loadingCajas = true;
                if (this.$store.state.accessCajaGrande === 1) {
                    this.itemsTabGeneral = [
                        'Caja Chica', 'Transactions', 'General Balance', 'Categories & Types',
                    ]
                }

                let exchangeRates = this.$store.state.exchangeRates;

                let ratesObj = null;

                try {
                    ratesObj = exchangeRates;
                } catch (e) {
                    console.error('Invalid exchangeRates JSON', e);
                }

                const data = ratesObj?.rates || {};

                if (!data || Object.keys(data).length === 0) {
                    this.rateEUR = 0;
                    this.rateGBP = 0;
                    this.noRates = true;
                } else {
                    this.rateEUR = data.EUR || 0;
                    this.rateGBP = data.GBP || 0;
                }

                // this.applications = await this.$store.dispatch('getAllApplications');
                this.initFinanciallocked();
                await this.reloadLastSquare();
                this.$store.dispatch('getContacts');
                let n = new Date();
                this.nowDate = this.formattedDate(n, 'date');
                this.cajaChicaDay = this.nowDate;
                this.nowYear =  n.getFullYear();
                this.balanceGeneralYear = this.nowYear;
                this.tabMonth = n.getMonth();
                await this.$store.dispatch('getOrganisations');
                let organisations = this.$store.state.organisations;
                for (let index = 0; index < organisations.length; index++) {
                    organisations[index].full_name = organisations[index].name;
                }
                this.selectContactsOrganisations = organisations.sort(this.dynamicSort('full_name'));
                this.selectClients = await this.$store.dispatch('getClientsIdName');
                this.selectClients.sort(this.dynamicSort('full_name'));
                await this.getData();
                if (this.$route.params.appId && this.$route.params.incomeType) {
                    this.newEditIncome(this.$route.params.appId, this.$route.params.currency, this.$route.params.incomeType, this.$route.params.clientId);
                } else if (this.$route.params.refund) {
                    this.newEditOutgoing(this.$route.params);
                } else if (this.$route.params.securityDeposit && this.$route.params.incomeType) {
                    this.newEditIncome(null, null, this.$route.params.incomeType, this.$route.params.clientId);
                } else if (this.$route.params.securityDeposit && this.$route.params.outgoingType) {
                    this.newEditOutgoing(this.$route.params);
                } else if (this.$route.params.transIdIncome) {
                    this.tabGeneral = 1;
                    await this.openDialogTransactionIncome(this.$route.params.transIdIncome);
                } else if (this.$route.params.transIdOutgoings) {
                    this.tabGeneral = 1;
                    await this.openDialogTransactionOutgoings(this.$route.params.transIdOutgoings);
                } else if (this.$route.params.paymentProfe) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.newEditOutgoing(this.$route.params.paymentProfe);
                } else if (this.$route.params.paymentFamily) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.newEditOutgoing(this.$route.params.paymentFamily);
                } else if (this.$route.params.paymentProject) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.newEditOutgoing(this.$route.params);
                } else if (this.$route.params.paymentAgency) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.newEditOutgoing(this.$route.params);
                } else if (this.$route.params.income_id) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.openEditIncome(this.$route.params);
                } else if (this.$route.params.outgoing_id) {
                    this.tabGeneral = 1;
                    this.tabTransactions = 1;
                    this.$store.dispatch('setLoadingApp', 0);
                    this.openEditOutgoings(this.$route.params);
                } else {
                    this.$store.dispatch('setLoadingApp', 0);
                }

            },

            formatMoney(val) {
                if (val === null || val === undefined) return null;
                return this.decUtil.format(val);
            },

            hasMoney(val) {
                if (val === null || val === undefined) return false;
                return !this.decUtil.toDec(val).isZero();
            },

            totalPaymentAmount(item) {
                const amount = item?.amount ?? 0;
                const fee = item?.bankTransferFee ?? 0;

                return this.decUtil
                    .toDec(amount)
                    .plus(fee);
            },

            paymentStatusText(resource) {
                const currency = resource.currency;

                const payment = this.decUtil.toDec(resource.payment);
                const paid = this.decUtil.toDec(resource.amountPaidReceiver);

                // no payment at all
                if (payment.isZero()) {
                return null;
                }

                // payment exists but nothing paid yet
                if (paid.isZero()) {
                return `Payment ${currency}${this.decUtil.format(payment)}`;
                }

                const open = payment.minus(paid);

                return (
                    `Payment ${currency}${this.decUtil.format(payment)} ` +
                    `- ${currency}${this.decUtil.format(paid)} paid = ` +
                    `${currency}${this.decUtil.format(open)} open`
                );
            },

            async reloadLastSquare () {
                let tmpLastSquare = await this.$store.dispatch('getLastSquare');
                if(tmpLastSquare.length > 0) {
                    this.lastSquareDateTime = this.formattedDate(tmpLastSquare[0].dateTime, 'dateTime');
                }
            },

            async getData() {
                console.log("getData test0")
                this.typesIncome = await this.$store.dispatch('getTypesIncome');
                for (let index = 0; index < this.typesIncome.length; index++) {
                    (this.typesIncome[index].obsolete) ? this.typesIncome[index].obsolete = this.formattedDate(this.typesIncome[index].obsolete, 'date') : this.typesIncome[index].obsolete = null;
                }
                this.typesOutgoings = await this.$store.dispatch('getTypesOutgoings');
                for (let index = 0; index < this.typesOutgoings.length; index++) {
                    (this.typesOutgoings[index].obsolete) ? this.typesOutgoings[index].obsolete = this.formattedDate(this.typesOutgoings[index].obsolete, 'date') : this.typesOutgoings[index].obsolete = null;
                }
                this.categoriesIncome = await this.$store.dispatch('getCategoriesIncome');
                for (let index = 0; index < this.categoriesIncome.length; index++) {
                    (this.categoriesIncome[index].obsolete) ? this.categoriesIncome[index].obsolete = this.formattedDate(this.categoriesIncome[index].obsolete, 'date') : this.categoriesIncome[index].obsolete = null;
                }
                this.categoriesOutgoings = await this.$store.dispatch('getCategoriesOutgoings');
                for (let index = 0; index < this.categoriesOutgoings.length; index++) {
                    (this.categoriesOutgoings[index].obsolete) ? this.categoriesOutgoings[index].obsolete = this.formattedDate(this.categoriesOutgoings[index].obsolete, 'date') : this.categoriesOutgoings[index].obsolete = null;
                }
                await this.changeDate(this.cajaChicaDay);
            },

            async getCurrentCajas() {
                console.log('getCurrentCajas start', this.tabGeneral, this.cajaChicaDay);

                this.loadingCajas = true;

                try {
                    this.currentBalances = [];

                    const date = this.formattedDate(
                        dayjs(this.cajaChicaDay).add(1, 'day'),
                        'date'
                    );

                    // -----------------------------
                    // Load balances
                    // -----------------------------
                    const balances = this.tabGeneral === 0
                    ? await this.$store.dispatch('getTotalBalancesDay', date)
                    : await this.$store.dispatch('getTotalBalancesMonth', date);

                    console.log('getCurrentCajas balances', balances);

                    // normalize balances
                    this.currentBalances = balances.map(row =>
                        Object.values(row)[0]
                    );

                    // -----------------------------
                    // Load outstanding deposits
                    // -----------------------------
                    const deposits = await this.$store.dispatch(
                        'getSecurityDepositsTotals'
                    );

                    this.outstandingDeposits = deposits;

                    const totalDepositsDec = deposits.reduce(
                        (sum, item) => sum.plus(item.totals),
                        this.decUtil.toDec(0)
                    );

                    // IO boundary
                    this.outstandingDepositsTotal = this.decUtil.format(totalDepositsDec);

                } finally {
                    this.loadingCajas = false;
                }
            },

            async getDataDay(day) {
                day = this.formattedDate(day, 'date');

                const month = parseInt(this.formattedDate(day, 'month')) - 1;
                await this.getDataMonth(month);

                const sumByCurrency = (items) => {
                    return items.reduce(
                        (acc, item) => {
                            if (item?.idSquare) return acc;

                            const amount = Number(item?.amount ?? 0);

                            if (item.currency === '$') {
                                acc.dollars += amount;
                            } else {
                                acc.soles += amount;
                            }

                            return acc;
                        },
                        { dollars: 0, soles: 0 }
                    );
                };

                const income = sumByCurrency(this.incomeDay || []);
                const outgoings = sumByCurrency(this.outgoingsDay || []);

                this.dayIncomeDollars = income.dollars;
                this.dayIncomeSoles = income.soles;

                this.dayOutgoingsDollars = outgoings.dollars;
                this.dayOutgoingsSoles = outgoings.soles;
            },

            async getDataMonth(month) {
                console.log("getDataMonth", month, this.cajaChicaDay);

                const isDayView = this.tabGeneral === 0;

                // Reset state
                if (isDayView) {
                    this.incomeDay = [];
                    this.outgoingsDay = [];
                } else {
                    this.incomeMonth = [];
                    this.outgoingsMonth = [];
                }

                this.$store.dispatch('setLoadingApp', 1);

                try {
                    const payload = {
                        month: month + 1,
                        year: this.balanceGeneralYear,
                    };

                    // -----------------------------
                    // Load income / outgoings
                    // -----------------------------
                    const [incomeRaw, outgoingsRaw] = await Promise.all([
                        isDayView
                            ? this.$store.dispatch('getIncomeDay', this.cajaChicaDay)
                            : this.$store.dispatch('getIncomeMonth', payload),
                        isDayView
                            ? this.$store.dispatch('getOutgoingsDay', this.cajaChicaDay)
                            : this.$store.dispatch('getOutgoingsMonth', payload)
                    ]);

                    let test = incomeRaw.filter(function(select_item) {
                        return select_item.id === 5802;
                    })

                    if (test && test.length > 0) {
                        console.log("test", test);
                    } else {
                        console.log("no test");
                    }

                    let incomeScope = this.prepareIncome(incomeRaw);
                    let outgoingsScope = this.prepareOutgoings(outgoingsRaw);

                    // -----------------------------
                    // Squares payload adjustment
                    // -----------------------------
                    let squaresPayload = { ...payload };

                    if (isDayView) {
                        squaresPayload.month = dayjs(this.cajaChicaDay).month() + 1;
                        squaresPayload.year = dayjs(this.cajaChicaDay).year();
                    }

                    this.squares = await this.$store.dispatch('getSquaresMonth', squaresPayload);

                    // -----------------------------
                    // Inject squares
                    // -----------------------------
                    const shouldIncludeSquare = (square) => {
                        return !isDayView || this.formattedDate(square.dateTime, 'date') === this.cajaChicaDay;
                    };

                    const mapSquare = (s) => ({
                        idSquare: s.id,
                        comments: s.comments,
                        dateTime: s.dateTime,
                        day: this.formattedDate(s.dateTime, 'date'),
                        date: this.formattedDate(s.dateTime, 'dayAndDate'),
                        exchangeRate: s.exchangeRate,
                        typeName: 'CajaChica Quadrada',
                        receiverName: this.formattedDate(s.dateTime, 'time'),
                        payerName: this.formattedDate(s.dateTime, 'time'),
                        client_id: null,
                        payerClient: null,
                        paymentMethod: 1,
                    });

                    this.squares
                        .filter(shouldIncludeSquare)
                        .map(mapSquare)
                        .forEach(square => {
                            incomeScope.push(square);
                            outgoingsScope.push(square);
                        });

                    // -----------------------------
                    // Sorting + freezing
                    // -----------------------------
                    const applyFreezeLogic = (list) => {
                        list.sort(this.dynamicSort('dateTime'));

                        if (!this.squares?.length) return;

                        let counterSquares = 0;

                        for (const item of list) {
                            if (item.idSquare) {
                                counterSquares++;
                                if (counterSquares === this.squares.length) break;
                                continue;
                            }

                            if (
                                (item.paymentMethod === 1 || item.paymentMethod === 5) &&
                                this.formattedDate(item.dateTime, 'dateTime') < this.lastSquareDateTime
                            ) {
                                item.frozen = true;
                            }
                        }
                    };

                    applyFreezeLogic(incomeScope);
                    applyFreezeLogic(outgoingsScope);

                    // -----------------------------
                    // Assign results
                    // -----------------------------
                    if (isDayView) {
                        this.incomeDay = incomeScope;
                        this.outgoingsDay = outgoingsScope;
                    } else {
                        this.incomeMonth = incomeScope;
                        this.outgoingsMonth = outgoingsScope;
                    }

                    this.getCurrentCajas();

                } finally {
                    this.$store.dispatch('setLoadingApp', 0);
                }
            },

            prepareIncome(incomeScope) {
                const TOLERANCE = this.decUtil.toDec(0.01);

                for (const income of incomeScope) {
                    if (!income) continue;

                    // -----------------------------
                    // Freeze logic
                    // -----------------------------
                    if (
                    this.formattedDate(income.dateTime, 'date') <= this.financialLocked
                    ) {
                    income.frozen = true;
                    }

                    // -----------------------------
                    // Normalize amounts
                    // -----------------------------
                    const amountDec = this.decUtil.toDec(income.amount ?? 0);
                    const feeDec = this.decUtil.toDec(income.bankTransferFee ?? 0);

                    income.amount = amountDec;              // canonical internal form
                    income.paymentDec = amountDec.plus(feeDec);

                    // -----------------------------
                    // Dates
                    // -----------------------------
                    income.date = this.formattedDate(income.dateTime, 'dayAndDate');
                    income.day = this.formattedDate(income.dateTime, 'date');

                    // -----------------------------
                    // Payer name resolution
                    // -----------------------------

                    if (income.client_id !== null) {
                        income.payerName = income.clientName;
                    } else if (income.agency_id !== null) {
                        income.payerName = income.agencyName;
                    } else if (income.contact_id !== null) {
                        income.payerName = income.contactName;
                    } else {
                        income.payerName = '';
                    }

                    // -----------------------------
                    // Normalize distribution
                    // -----------------------------
                    const distributedDec = this.decUtil.toDec(
                    income.incomeDistributed ?? 0
                    );

                    income.incomeDistributedDec = distributedDec;

                    // -----------------------------
                    // Type metadata (single lookup)
                    // -----------------------------
                    if (income.type_id) {
                    const type = this.typesIncome.find(
                        e => e.id === income.type_id
                    );

                    if (type) {
                        income.typeName = type.name;
                        income.payer = type.payer;
                        income.accountable = type.accountable;
                        income.categoryId = type.category_id;
                        income.categoryName = type.name;
                    }
                    }

                    // -----------------------------
                    // Distribution validation
                    // -----------------------------
                    income.distError = false;

                    if (
                    income.accountable === 1 &&
                    (income.currency === '$' || income.currency === 'S/.')
                    ) {
                    const feeIncluded =
                        income.transferFeeIncluded === true ||
                        income.transferFeeIncluded === 1;

                    let expectedDec = this.decUtil.toDec(
                        income.amountDollars ?? 0
                    );

                    if (feeIncluded) {
                        expectedDec = expectedDec.plus(feeDec);
                    }

                    const diff = expectedDec
                        .minus(distributedDec)
                        .abs();

                    income.distError = diff.gt(TOLERANCE);
                    }
                }

                return incomeScope;
            },

            prepareOutgoings(outgoingsScope) {
                const TOLERANCE = this.decUtil.toDec(0.05);

                for (const o of outgoingsScope) {
                    if (!o) continue;

                    // -----------------------------
                    // Freeze logic
                    // -----------------------------
                    if (
                    this.formattedDate(o.dateTime, 'date') <= this.financialLocked
                    ) {
                    o.frozen = true;
                    }

                    // -----------------------------
                    // Receiver name resolution
                    // -----------------------------
                    if (o.client_id !== null) o.receiverName = o.clientName;
                    if (o.contact_id !== null) o.receiverName = o.contactName;
                    if (o.organisation_id !== null) o.receiverName = o.organisationName;

                    if (o.application_id !== null) {
                        o.receiverName =
                        o.payerClientName !== null
                        ? o.payerClientName
                        : o.payerAgencyName;
                    }

                    // -----------------------------
                    // Special payer logic
                    // -----------------------------
                    if (o.type_id === 79 && o.client_id !== null) {
                    o.payerClient = o.client_id;
                    }

                    // -----------------------------
                    // Normalize amounts
                    // -----------------------------
                    const amountDec = this.decUtil.toDec(o.amount ?? 0);
                    const feeDec = this.decUtil.toDec(o.bankTransferFee ?? 0);

                    o.amount = amountDec.toNumber?.() ?? amountDec;
                    o.paymentDec = amountDec.plus(feeDec); // Decimal ONLY

                    // -----------------------------
                    // Dates
                    // -----------------------------
                    o.date = this.formattedDate(o.dateTime, 'dayAndDate');
                    o.day = this.formattedDate(o.dateTime, 'date');

                    // -----------------------------
                    // Type metadata (single lookup)
                    // -----------------------------
                    if (o.type_id) {
                    const type = this.typesOutgoings.find(
                        e => e.id === o.type_id
                    );

                    if (type) {
                        o.typeName = type.name;
                        o.receiver = type.receiver;
                        o.accountable = type.accountable;
                        o.categoryId = type.category_id;
                        o.categoryName = type.name;
                    }
                    }

                    // -----------------------------
                    // Payment method
                    // -----------------------------
                    if (o.paymentMethod) {
                    const pm = this.$store.state.paymentMethods.find(
                        e => e.id === o.paymentMethod
                    );
                    if (pm) o.paymentMethodName = pm.method;
                    }

                    // -----------------------------
                    // Distribution validation
                    // -----------------------------
                    o.distError = false;

                    if (
                    o.accountable === 1 &&
                    o.outgoingsDistributed !== null &&
                    o.outgoingsDistributed !== undefined
                    ) {
                    const distributedDec = this.decUtil
                        .toDec(o.outgoingsDistributed)
                        .times(o.exchangeRate);

                    const discountPct = this.decUtil.toDec(
                        o.discount_payment_teacher ?? 0
                    );

                    const correctionDec = this.decUtil.toDec(
                        o.correction ?? 0
                    );

                    const expectedDec = distributedDec
                        .times(this.decUtil.toDec(1).minus(discountPct.div(100)))
                        .plus(correctionDec);

                    const actualDec = this.decUtil.toDec(o.amountSoles ?? 0);

                    const diff = expectedDec.minus(actualDec).abs();

                    o.distError = diff.gt(TOLERANCE);
                    }
                }

                return outgoingsScope;
            },

            itemRowBackgroundIncome: function (item) {
                if (item.idSquare) {
                    return 'green-background'
                } else if (item.categoryId === 15) {
                    return 'orange-background'
                } else if (item.categoryId === 19) {
                    return 'blue-background'
                } else if (item.distError) {
                    return 'red-background'
                } else {
                    return 'white-background'
                }
            },

            itemRowBackgroundOutgoings: function (item) {
                if (item.idSquare) {
                    return 'green-background'
                } else if (item.categoryId === 25) {
                    return 'orange-background'
                } else if (item.categoryId === 15) {
                    return 'blue-background'
                } else if (item.distError) {
                    return 'red-background'
                } else {
                    return 'white-background'
                }
            },

            changeGeneralTab(event) {
                if (event === 0) {
                    this.getDataDay(this.cajaChicaDay)
                }
                if (event === 2) {
                    this.getDataMonth(this.tabMonth)
                    // this.filterBalanceGeneral = 'All';
                }
            },

            // Types Income

            selectTypesIncome () {
                if (this.tabGeneral === 0) {
                        return this.typesIncome.filter(function(select_item) {
                        return select_item.obsolete === null && select_item.showCajaChica === 1;
                    })
                } else {
                        return this.typesIncome.filter(function(select_item) {
                        return select_item.obsolete === null;
                    })
                }
            },

            editTypeIncome (item) {
                this.editedTypeIncomeIndex = this.typesIncome.indexOf(item)
                this.editedTypeIncomeItem = Object.assign({}, item)
                this.dialogTypeIncome = true
            },

            async deleteTypeIncome (item) {
                this.editedTypeIncomeIndex = this.typesIncome.indexOf(item)
                this.editedTypeIncomeItem = Object.assign({}, item)
                this.dialogTypeIncomeDelete = true
            },

            async deleteTypeIncomeConfirm () {
                let response = await this.$store.dispatch('deleteTypeIncome', this.editedTypeIncomeItem.id);
                if (response.data.affectedRows === 1) {
                    this.$store.dispatch('successMessage', 'Type deleted');
                } else {
                    this.$store.dispatch('errorMessage', 'Something went wrong');
                }
                await this.getData();
                this.closeDeleteTypeIncome()
            },

            setObsoleteTypeIncome(event) {
                if (event) {
                    this.editedTypeIncomeItem.obsolete = dayjs().format("YYYY-MM-DD")
                } else {
                    this.editedTypeIncomeItem.obsolete = null
                }
            },

            closeTypeIncome () {
                this.dialogTypeIncome = false
                this.$nextTick(() => {
                    this.editedTypeIncomeItem = Object.assign({}, this.defaultTypeIncome)
                    this.editedTypeIncomeIndex = -1
                })
            },

            closeDeleteTypeIncome () {
                this.dialogTypeIncomeDelete = false
                this.$nextTick(() => {
                this.editedTypeIncomeItem = Object.assign({}, this.defaultTypeIncome)
                    this.editedTypeIncomeIndex = -1
                })
            },

            async saveTypeIncome () {
                if(this.$refs.dialogTypeIncomeForm.validate()){
                    let tmp = this.editedTypeIncomeItem.name;
                    let doubleName = this.typesIncome.filter(function(select_item) {
                            return select_item.name === tmp;
                        }
                    )
                    if (doubleName.length > 0 && this.editedTypeIncomeIndex !== this.typesIncome.indexOf(doubleName[0])) {
                        this.$store.dispatch('errorMessage', 'The name "' + this.editedTypeIncomeItem.name + '" is already in use!');
                        return;
                    } else {
                        await this.$store.dispatch('insertTypeIncome', this.editedTypeIncomeItem);
                        await this.getData();
                    }
                    this.closeTypeIncome()
                }
            },

            // Types Outgoings

            selectTypesOutgoings (typeId) {
                let list = [];
                if (this.tabGeneral === 0) {
                    list = this.typesOutgoings.filter(function(select_item) {
                        return select_item.obsolete === null && select_item.showCajaChica === 1;
                    })
                } else {
                    list = this.typesOutgoings.filter(function(select_item) {
                        return select_item.obsolete === null;
                    })
                }
                if (this.typesOutgoings.some(item => item.id === typeId)) {
                    list.push(this.typesOutgoings.find(item => item.id === typeId));
                }
                list = list.sort(this.dynamicSort('name'));
                return list;
            },

            editTypeOutgoings (item) {
                this.editedTypeOutgoingsIndex = this.typesOutgoings.indexOf(item)
                this.editedTypeOutgoingsItem = Object.assign({}, item)
                this.dialogTypeOutgoings = true
            },

            async deleteTypeOutgoings (item) {
                this.editedTypeOutgoingsIndex = this.typesOutgoings.indexOf(item)
                this.editedTypeOutgoingsItem = Object.assign({}, item)
                this.dialogTypeOutgoingsDelete = true
            },

            async deleteTypeOutgoingsConfirm () {
                let response = await this.$store.dispatch('deleteTypeOutgoings', this.editedTypeOutgoingsItem.id);
                if (response.data.affectedRows === 1) {
                    this.$store.dispatch('successMessage', 'Type deleted');
                } else {
                    this.$store.dispatch('errorMessage', 'Something went wrong');
                }
                await this.getData();
                this.closeDeleteTypeOutgoings()
            },

            setObsoleteTypeOutgoings(event) {
                if (event) {
                    this.editedTypeOutgoingsItem.obsolete = dayjs().format("YYYY-MM-DD")
                } else {
                    this.editedTypeOutgoingsItem.obsolete = null
                }
                
            },

            closeTypeOutgoings () {
                this.dialogTypeOutgoings = false
                this.editedTypeOutgoingsItem = Object.assign({}, this.defaultTypeOutgoings)
                this.editedTypeOutgoingsIndex = -1
            },

            closeDeleteTypeOutgoings () {
                this.dialogTypeOutgoingsDelete = false;
                this.editedTypeOutgoingsItem = Object.assign({}, this.defaultTypeOutgoings)
                this.editedTypeOutgoingsIndex = -1
            },

            async saveTypeOutgoings () {
                if(this.$refs.dialogTypeOutgoingsForm.validate()){
                    let tmp = this.editedTypeOutgoingsItem.name;
                    let doubleName = this.typesOutgoings.filter(function(select_item) {
                        return select_item.name === tmp;
                    })
                    if (doubleName.length > 0 && this.editedTypeOutgoingsIndex !== this.typesOutgoings.indexOf(doubleName[0])) {
                        this.$store.dispatch('errorMessage', 'The name "' + this.editedTypeOutgoingsItem.name + '" is already in use!');
                        return;
                    } else {
                        await this.$store.dispatch('insertTypeOutgoings', this.editedTypeOutgoingsItem);
                        await this.getData();
                    }
                    this.closeTypeOutgoings()
                }
            },

            // Income Edit

            async openDialogTransactionIncome (transIdIncome) {
                this.transactionIncome = await this.$store.dispatch('getTransactionIncomeId', transIdIncome)
                this.distributionsIncomeTable = await this.$store.dispatch('getDistributionsIncomeTransactionId', transIdIncome)
                if (this.transactionIncome.length === 0 || this.distributionsIncomeTable === 0) {
                    this.dialogTransactionIncome = false;
                } else {
                    this.dialogTransactionIncome = true;
                }
            },

            async editIncome (item) {
                this.$store.dispatch('setLoadingApp', 1)

                if (this.tabGeneral === 0) {
                    this.editedIncomeIndex = this.incomeDay.indexOf(item)
                } else {
                    this.editedIncomeIndex = this.incomeMonth.indexOf(item)
                }

                this.editedIncomeItem = Object.assign({}, item);
                this.distributionsIncomeNew = await this.$store.dispatch('getDistributionsIncomeId', this.editedIncomeItem.id);
                this.distributionsIncomeOld = JSON.parse(JSON.stringify(this.distributionsIncomeNew));
                if (this.editedIncomeItem.client_id) {
                    this.transferFeeIncluded = 0;
                    if (this.editedIncomeItem.accountable === 1) {
                        this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerClientId', this.editedIncomeItem.client_id);
                        console.log("editIncome #1 selectApplicationsPayer", this.selectApplicationsPayer)
                    }
                }
                
                if (this.editedIncomeItem.agency_id) {
                    this.transferFeeIncluded = this.getTransferFeeIncluded(this.editedIncomeItem.agency_id);
                    if (this.editedIncomeItem.accountable === 1) {
                        this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerAgencyId', this.editedIncomeItem.agency_id);
                        console.log("editIncome #2 selectApplicationsPayer", this.selectApplicationsPayer)
                    }
                }
                
                // this.createApplicationsPayerItems();
                this.editingIncome = true;
                this.dialogEditIncome = true;

                this.$store.dispatch('setLoadingApp', 0);
            },

            async newEditIncome (appId, currency, incomeType, clientId) {
                console.log('newEditIncome', appId, currency, incomeType, clientId);
                if (this.formattedDate(new Date(), 'date') <= this.financialLocked) {
                    this.$store.dispatch('errorMessage', 'Caja closed');
                    return;
                }
                if (appId !== null) {
                    this.tabGeneral = 1;
                    this.distributionsIncomeOld = [];
                    this.distributionsIncomeNew = [];
                    let app = await this.$store.dispatch('getApplicationId', appId);
                    if (app.payerClient !== null) {
                        this.editedIncomeItem.client_id = app.payerClient;
                        this.editedIncomeItem.paymentMethod = 2;
                        this.transferFeeIncluded = 0;
                        this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerClientId', this.editedIncomeItem.client_id);
                    } else if (app.payerAgency !== null) {
                        this.editedIncomeItem.agency_id = app.payerAgency;
                        this.editedIncomeItem.paymentMethod = 4;
                        this.transferFeeIncluded = this.getTransferFeeIncluded(this.editedIncomeItem.agency_id);
                        this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerAgencyId', this.editedIncomeItem.agency_id);
                    }
                    // this.createApplicationsPayerItems();

                    const total = this.decUtil.toDec(app.totalPrice);
                    const paid = this.decUtil.toDec(app.amountPaidApplication);
                    const rate = this.decUtil.toDec(app.exchangeRate);

                    const remaining = total.minus(paid);

                    if (currency === 'dollars') {
                        this.editedIncomeItem.currency = '$';
                        this.editedIncomeItem.amount = this.decUtil.format(remaining);
                    } else {
                        this.editedIncomeItem.currency = 'S/.';
                        this.editedIncomeItem.amount = this.decUtil.format(remaining.times(rate));
                    }

                    this.editedIncomeItem.type_id = incomeType;
                    this.amountDistributedIncome = this.editedIncomeItem.amount;
                    await this.addDistributionIncome(app);
                } else if (incomeType !== null) {
                    this.editedIncomeItem.type_id = incomeType;
                    this.editedIncomeItem.client_id = clientId;
                    this.editedIncomeItem.accountable = 0;
                    this.tabGeneral = 1;
                }
                // this.editedIncomeItem.setAllDistributed = 0;
                this.editedIncomeItem.transaction_id = null;
                this.editedIncomeItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                this.editingIncome = false;
                this.dialogEditIncome = true;
            },

            closeEditIncome () {
                this.dialogEditIncome = false;
                this.editedIncomeItem = Object.assign({}, this.defaultIncomeItem);
                this.editedIncomeIndex = -1;
                this.$refs.formIncome.reset();
                this.distributionsIncomeOld = [];
                this.distributionsIncomeNew = [];
                this.loadingButton = false;
            },

            deleteIncome (item) {
                this.editedIncomeIndex = this.incomeDay.indexOf(item);
                this.editedIncomeItem = Object.assign({}, item);
                this.dialogIncomeDelete = true;
            },

            closeDeleteIncome () {
                this.editedIncomeItem = Object.assign({}, this.defaultIncomeItem);
                this.editedIncomeIndex = -1;
                this.dialogIncomeDelete = false;
                this.loadingButton = false;
            },

            async deleteIncomeConfirm () {
                this.loadingButton = true;
                if (this.editedIncomeItem.idSquare) {
                    await this.$store.dispatch('deleteSquare', this.editedIncomeItem.idSquare);
                    this.reloadLastSquare();
                } else {
                    await this.$store.dispatch('deleteIncome', this.editedIncomeItem.id);
                }
                this.cajaChicaDay = this.formattedDate(this.editedIncomeItem.dateTime, 'date');
                this.closeDeleteIncome();
                await this.getDataDay(this.cajaChicaDay);
                this.transactionsIncome = [];
            },

            async choosePayer(payer) {
                if (payer === 'client') {
                    this.editedIncomeItem.agency_id = null;
                    this.editedIncomeItem.contact_id = null;
                    this.transferFeeIncluded = 0;
                }
                if (payer === 'agency') {
                    this.editedIncomeItem.contact_id = null;
                    this.editedIncomeItem.client_id = null;
                    this.transferFeeIncluded = this.getTransferFeeIncluded(this.editedIncomeItem.agency_id);
                }
                if (payer === 'contact') {
                    this.editedIncomeItem.agency_id = null;
                    this.editedIncomeItem.client_id = null;
                    this.transferFeeIncluded = 0;
                }
                if (this.editedIncomeItem.client_id && this.editedIncomeItem.accountable === 1) {
                    this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerClientId', this.editedIncomeItem.client_id);
                    // this.createApplicationsPayerItems();
                }
                if (this.editedIncomeItem.agency_id && this.editedIncomeItem.accountable === 1) {
                    this.selectApplicationsPayer = await this.$store.dispatch('getApplicationsPayerAgencyId', this.editedIncomeItem.agency_id);
                    // this.createApplicationsPayerItems();
                }
                // this.renderDialog = Math.random();
            },

            async getTransactionsIncome(scope) {
                if (scope ===  'all') {
                    this.loadingbuttonLoadTransactionsClosed = true;
                    this.transactionsIncome = await this.$store.dispatch('getAllTransactionsIncome');
                    this.loadingbuttonLoadTransactionsClosed = false;
                } else {
                    this.loadingbuttonLoadTransactionsOpen = true;
                    this.transactionsIncome = await this.$store.dispatch('getOpenTransactionsIncome');
                    this.loadingbuttonLoadTransactionsOpen = false;
                }
            },

            async openAddDistributionsIncome () {
                // this.createApplicationsPayerItems();

                if (this.selectApplicationsPayerItems.length === 0) {
                    this.$store.dispatch(
                    'errorMessage',
                    'There are no applications to distribute'
                    );
                    return;
                }

                // normalize inputs (no state mutation)
                const base = this.decUtil.toDec(this.editedIncomeItem.amount);
                const distributed = this.decUtil.toDec(this.distributionsTotalIncome);
                const fee = this.decUtil.toDec(this.editedIncomeItem.bankTransferFee);

                const feeIncluded =
                    this.transferFeeIncluded === true || this.transferFeeIncluded === 1;

                // calculation
                let result = base.minus(distributed);

                if (feeIncluded) {
                    result = result.plus(fee);
                }

                // IO boundary
                this.amountDistributedIncome = this.decUtil.format(result);

                // UI
                this.dialog_add_distributionIncome = true;
            },

            addDistributionIncome(distribution) {

                if (!this.amountDistributedIncome ||
                    this.decUtil.toDec(this.amountDistributedIncome).lte(0)) {

                    this.$store.dispatch('errorMessage', 'Please insert a amount to ditribute');
                    return;
                }

                distribution.application_id = distribution.id;
                distribution.income_id = this.editedIncomeItem.id;

                let amountDec;

                if (this.dialog_add_distributionIncome) {

                    // convert UI value → Decimal
                    amountDec = this.decUtil.toDec(this.amountDistributedIncome);

                } else {

                    const total = this.decUtil.toDec(distribution.totalPrice);
                    const paid  = this.decUtil.toDec(distribution.amountPaidApplication);

                    amountDec = total.minus(paid);
                }

                // store numeric value for DB
                distribution.amount = Number(amountDec);

                const posPayer = this.selectApplicationsPayer
                    .map(e => e.id)
                    .indexOf(distribution.application_id);

                const currentPaid = this.decUtil.toDec(
                    this.selectApplicationsPayer[posPayer].amountPaidApplication
                );

                this.selectApplicationsPayer[posPayer].amountPaidApplication =
                    Number(currentPaid.plus(amountDec));

                this.distributionsIncomeNew.push(distribution);

                console.log("addDistributionIncome", this.distributionsIncomeNew);

                this.dialog_add_distributionIncome = false;
            },

            async deleteDistributionIncome (event) {
                let pos = this.distributionsIncomeNew.map(function(e) { return e.id; }).indexOf(event.id);
                let posPayer = this.selectApplicationsPayer.map(function(e) { return e.id; }).indexOf(event.application_id);
                console.log('deleteDistributionIncome', posPayer, this.selectApplicationsPayer);
                if (posPayer > -1) {
                    this.selectApplicationsPayer[posPayer].amountPaidApplication = this.selectApplicationsPayer[posPayer].amountPaidApplication - event.amount;
                }
                if (pos > -1) {
                    this.distributionsIncomeNew.splice(pos, 1);
                }
            },

            async saveIncome() {
                this.nowDate = this.formattedDate(new Date(), 'date');
                if(this.$refs.formIncome.validate()) {
                    if ((this.editedIncomeItem.paymentMethod === 1 || this.editedIncomeItem.paymentMethod === 5) && this.lastSquareDateTime > this.formattedDate(this.editedIncomeItem.dateTime, 'dateTime')) {
                        this.$store.dispatch('errorMessage', 'Caja Chica already closed for that date');
                        return;
                    } else {
                        
                        // if (this.editedIncomeItem.currency === '$' || this.editedIncomeItem.currency === 'S/.') {
                        //     this.editedIncomeItem.setAllDistributed = 0;
                        // }
                        if (this.tabGeneral === 0) {
                            this.editedIncomeItem.paymentMethod = 1;
                        }
                        if (this.editedIncomeItem.type_id === 81 || this.editedIncomeItem.type_id === 5) {
                            this.editedIncomeItem.paymentMethod = 5;
                        }
                        if (this.editedIncomeItem.bankTransferFee === null) {
                            this.editedIncomeItem.bankTransferFee = 0;
                        }
                        if (this.editedIncomeItem.dateTime) {
                            if (this.formattedDate(this.editedIncomeItem.dateTime, 'date') === this.nowDate) {
                                this.editedIncomeItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                            } else {
                                this.editedIncomeItem.dateTime = this.formattedDate(this.editedIncomeItem.dateTime, 'dateTime');
                            }
                        } else {
                            this.editedIncomeItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                        }
                        this.cajaChicaDay = this.formattedDate(this.editedIncomeItem.dateTime, 'date');
                        this.editedIncomeItem.exchangeRate = this.$store.state.exchangeRate;


                        // check if distributed
                        
                        // accountable = 1 ?
                        // console.log('saveIncome #1', this.editedIncomeItem.accountable, this.editedIncomeItem.setAllDistributed);
                        if ((this.editedIncomeItem.accountable || this.editedIncomeItem.accountable === 1)) {

                            this.editedIncomeItem.incomeDistributed = this.distributionsIncomeNew
                              .reduce(
                                  (sum, item) =>
                                      sum.plus(this.decUtil.toDec(item.amount ?? 0)),
                                  this.decUtil.toDec(0)
                              )
                              .toNumber();
                            
                            if (this.editedIncomeItem.currency !== '$' && this.editedIncomeItem.currency !== 'S/.') {

                                if (this.editedIncomeItem.incomeDistributed === 0) {
                                    this.$store.dispatch('errorMessage', 'Please insert a correct amount to distribute');
                                    return;
                                }

                            } else {
                                
                                console.log('saveIncome #2', this.editedIncomeItem.incomeDistributed);
                                const income = this.editedIncomeItem;

                                // 1️⃣ normalize amount in USD (Decimal)
                                const amountUSD =
                                income.currency === '$'
                                    ? this.decUtil.toDec(income.amount)
                                    : this.decUtil.toDec(income.amount).div(income.exchangeRate);

                                // keep as Decimal (do NOT format yet)
                                income.amountDollars = amountUSD;

                                // 2️⃣ validate distributed amount
                                const feeIncluded =
                                income.transferFeeIncluded === true || income.transferFeeIncluded === 1;

                                let expected = amountUSD;

                                if (feeIncluded) {
                                    expected = expected.plus(income.bankTransferFee);
                                }

                                const distributed = this.decUtil.toDec(income.incomeDistributed);

                                // default tolerance = 0.01
                                if (!decUtil.equals(expected, distributed)) {
                                    console.log(
                                        'saveIncome mismatch',
                                        this.decUtil.format(expected),
                                        this.decUtil.format(distributed)
                                    );

                                    this.$store.dispatch(
                                        'errorMessage',
                                        'Please insert a correct amount to distribute'
                                    );
                                    return;
                                }
                            }

                        }
                        
                        this.loadingButton = true;

                        let transactionId = new Date();
                        transactionId = transactionId.getTime();

                        this.editedIncomeItem.transaction_id = transactionId;
                        this.editedIncomeItem.executeStatusTrees = true;
                        let newIncomeId = await this.$store.dispatch('insertIncome', this.editedIncomeItem);

                        console.log('saveIncome #4', newIncomeId);

                        this.editedIncomeItem.id = newIncomeId;
                        for (let index = 0; index < this.distributionsIncomeOld.length; index++) {
                            if (this.distributionsIncomeNew.map(function(e) { return e.id; }).indexOf(this.distributionsIncomeOld[index].id) === -1) {
                                await this.$store.dispatch('deleteDistributionIncomeId', this.distributionsIncomeOld[index].id);
                            }
                        }
                        
                        for (let index = 0; index < this.distributionsIncomeNew.length; index++) {

                            this.distributionsIncomeNew[index].income_id = newIncomeId;
                            this.distributionsIncomeNew[index].amountIncome = this.editedIncomeItem.amount;
                            this.distributionsIncomeNew[index].transaction_id = transactionId;
                            this.distributionsIncomeNew[index].id = null;
                            // console.log('saveIncome #5', this.distributionsIncomeNew[index]);
                            await this.$store.dispatch('insertDistributionIncome', this.distributionsIncomeNew[index]);

                        }

                        this.balanceGeneralYear = this.formattedDate(this.editedIncomeItem.dateTime, 'year');
                        this.tabMonth = parseInt(this.formattedDate(this.editedIncomeItem.dateTime, 'month')) - 1;
                        this.closeEditIncome();
                        await this.getDataDay(this.cajaChicaDay);
                        this.transactionsIncome = [];
                    }
                }
            },
            
            changeIncomeType() {
                let tmp = this.editedIncomeItem.type_id;
                this.editedIncomeItem.accountable = 0;
                this.editedIncomeItem.fixedPaymentMethod = 0;
                if (tmp !== null && tmp) {
                    let typesIncome = this.typesIncome.filter(function(select_item) {
                        return select_item.id === tmp;
                    })[0];
                    this.editedIncomeItem.payer = typesIncome.payer;
                    this.editedIncomeItem.accountable = typesIncome.accountable;
                    if (typesIncome.paymentMethod) {
                        this.editedIncomeItem.paymentMethod = typesIncome.paymentMethod;
                        this.editedIncomeItem.fixedPaymentMethod = 1;
                    }
                    if (tmp === 22) {
                        this.editedIncomeItem.currency = 'S/.'
                    }
                    console.log(tmp)
                    if (tmp === 29 || tmp === 30) {
                        this.editedIncomeItem.currency = '$'
                    }
                }
            },

            async openEditIncome (event) {
                this.balanceGeneralYear = this.formattedDate(event.paidOn, 'year');
                // this.tabMonth = parseInt(this.formattedDate(event.paidOn, 'month')) - 1;
                await this.getDataDay(event.paidOn)
                let tmp = event.income_id;
                let item = this.incomeMonth.filter(function(select_item) {
                    return select_item.id === tmp;
                })[0]
                this.editIncome(item);
                this.dialogTransactionIncome = false;
                this.$store.dispatch('saveDataForReport', );
            },

            // Outgoings Edit

            async openDialogTransactionOutgoings (transIdOutgoings) {
                console.log('openDialogTransactionOutgoings', transIdOutgoings);
                Promise.all([this.transactionOutgoing = await this.$store.dispatch('getTransactionOutgoingsId', transIdOutgoings), this.distributionsOutgoingsTable = await this.$store.dispatch('getDistributionsOutgoingsTransactionId', transIdOutgoings)]).then(() => {
                    // console.log('openDialogTransactionOutgoings #1', this.transactionOutgoing, this.distributionsOutgoingsTable);
                    
                    if (this.transactionOutgoing.length === 0 || this.distributionsOutgoingsTable === 0) {
                        this.dialogTransactionOutgoings = false;
                    } else {
                        this.dialogTransactionOutgoings = true;
                    }
                })
            },

            async editOutgoing (item) {
                this.$store.dispatch('setLoadingApp', 1)
                if (this.tabGeneral === 0) {
                    this.editedOutgoingIndex = this.outgoingsDay.indexOf(item)
                } else {
                    this.editedOutgoingIndex = this.outgoingsMonth.indexOf(item)
                }
                this.editedOutgoingsItem = Object.assign({}, item)
                this.distributionsOutgoingsNew = await this.$store.dispatch('getDistributionsOutgoingId', this.editedOutgoingsItem.id);
                this.distributionsOutgoingsOld = JSON.parse(JSON.stringify(this.distributionsOutgoingsNew));
                console.log('editOutgoing test1', this.distributionsOutgoingsNew, this.editedOutgoingsItem.id);
                if (this.editedOutgoingsItem.contact_id) {
                    // console.log('editOutgoing test2');
                    this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverContactId', this.editedOutgoingsItem.contact_id);
                    // console.log('editOutgoing test3', this.editedOutgoingsItem.contact_id, this.selectResourceReceiver);
                }
                if (this.editedOutgoingsItem.organisation_id) {
                    // console.log('editOutgoing test4');
                    this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverOrganisationId', this.editedOutgoingsItem.organisation_id);
                    // console.log('editOutgoing test5');
                }
                this.classesPayment = [];
                this.classesPaymentOld = [];
                if (this.editedOutgoingsItem.type_id === 12 || this.editedOutgoingsItem.type_id === 13 || this.editedOutgoingsItem.type_id === 32) {
                    this.classesPayment = await this.$store.dispatch('getClassesOutgoingId', this.editedOutgoingsItem.id);
                    this.classesPaymentOld = JSON.parse(JSON.stringify(this.classesPayment));
                    if (this.classesPayment.length === 0) {
                        this.$store.dispatch('warningMessage', 'No classes to pay');
                    } else {
                        this.addStudentsShortToClassesPayment();
                    }
                }
                this.editingOutgoing = true;
                this.dialogEditOutgoing = true;
                this.$store.dispatch('setLoadingApp', 0);
            },

            addStudentsShortToClassesPayment() {
                for (let index = 0; index < this.classesPayment.length; index++) {
                    let students_short = "";
                    // console.log('addStudentsShortToClassesPayment', this.classesPayment[index].studentsObject);
                    let studentsObject = [];
                    if (typeof this.classesPayment[index].studentsObject === 'string') {
                        studentsObject = JSON.parse(this.classesPayment[index].studentsObject);
                    } else {
                        studentsObject = this.classesPayment[index].studentsObject;
                    }
                    for (let index2 = 0; index2 < studentsObject.length; index2++) {
                        let firstLetter = studentsObject[index2].full_name.trim()[0];
                        let lastWord = studentsObject[index2].full_name.trim().split(/\s+/).pop();
                        students_short += firstLetter + " " + lastWord + ", ";
                    }
                    students_short = students_short.substring(0, students_short.length - 2);
                    this.classesPayment[index].students_short = students_short;
                }
                this.classesPayment = this.classesPayment.sort(this.dynamicSort('start'));
            },

            async newEditOutgoing(input) {
                console.log('newEditOutgoing', input);
                if (this.formattedDate(new Date(), 'date') <= this.financialLocked) {
                    this.$store.dispatch('errorMessage', 'Caja closed');
                    return;
                }
                this.editedOutgoingsItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                this.distributionsOutgoingsNew = [];
                this.distributionsOutgoingsOld = [];
                var distribution = {};
                this.editedOutgoingsItem.currency = '$';
                this.editedOutgoingsItem.correction = 0;
                if (input) {
                    if (input.securityDeposit) {
                        this.editedOutgoingsItem.type_id = input.outgoingType;
                        this.editedOutgoingsItem.accountable = 0;
                        this.editedOutgoingsItem.paymentMethod = 2;
                        this.editedOutgoingsItem.currency = '$';
                        this.editedOutgoingsItem.client_id = input.clientId;
                    }
                    else if (input.teacher) {
                        this.editedOutgoingsItem.teacher_id = input.teacher;
                        this.editedOutgoingsItem.currency = 'S/.';
                        this.editedOutgoingsItem.accountable = 1;
                        this.editedOutgoingsItem.paymentMethod = 4;
                        this.editedOutgoingsItem.discount_payment_teacher = input.discountPayment;
                        this.editedOutgoingsItem.correction = input.correction;
                        this.editedOutgoingsItem.comments_correction = input.comments_correction;
                        if (input.classes.length > 0) {
                            this.editedOutgoingsItem.contact_id = input.contactId;
                            if (input.language === 'English') {
                                this.editedOutgoingsItem.type_id = 13;
                            } else if (input.language === 'Spanish') {
                                this.editedOutgoingsItem.type_id = 12;
                            } else {
                                this.editedOutgoingsItem.type_id = 32;
                            }
                            this.classesPayment = JSON.parse(JSON.stringify(input.classes));
                            this.classesPaymentOld = [];
                            this.prepareClassesNotPaid(null);
                        }
                        this.editedOutgoingsItem.receiver = 'Contact Teacher'
                    }
                    else if (input.family) {
                        this.editedOutgoingsItem.accountable = 1;
                        distribution = {}
                        this.editedOutgoingsItem.currency = 'S/.';
                        this.editedOutgoingsItem.type_id = 4;
                        this.editedOutgoingsItem.contact_id = input.contact_id;
                        this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverContactId', this.editedOutgoingsItem.contact_id);
                        // console.log('paymentFamily', input, this.editedOutgoingsItem.contact_id);
                        let array = input.resources;
                        for (let index = 0; index < array.length; index++) {
                            distribution.outgoing_id = null;
                            distribution.resource_id = array[index].id;
                            distribution.resourceName = array[index].resourceName;
                            distribution.full_name = array[index].full_name;
                            distribution.payment = array[index].toPayNow;
                            distribution.amount = distribution.payment;
                            distribution.currencyResource = array[index].currency;
                            distribution.exchangeRate = array[index].exchangeRate;
                            this.distributionsOutgoingsNew.push(distribution);
                            let posReceiver = this.selectResourceReceiver.map(function(e) { return e.id; }).indexOf(distribution.resource_id);
                            // console.log('paymentFamily #2', array[index].id, this.selectResourceReceiver, posReceiver);
                            this.selectResourceReceiver[posReceiver].amountPaidReceiver = this.selectResourceReceiver[posReceiver].amountPaidReceiver + distribution.amount
                            distribution = {};
                        }
                        this.editedOutgoingsItem.receiver = 'Contact Accommodation'
                        this.editedOutgoingsItem.amount = input.totalPayment;
                    }
                    else if (input.paymentProject) {
                        console.log('paymentProject', input);
                        this.editedOutgoingsItem.accountable = 1;
                        this.editedOutgoingsItem.currency = '$';
                        distribution = {};
                        distribution.outgoing_id = null;
                        this.editedOutgoingsItem.type_id = 14;
                        this.editedOutgoingsItem.organisation_id = input.resources[0].organisation_id;
                        this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverOrganisationId', this.editedOutgoingsItem.organisation_id);
                        console.log('paymentProject #1', input.resources[0], this.selectResourceReceiver);
                        let array = input.resources;
                        for (let index = 0; index < array.length; index++) {
                            distribution.resource_id = array[index].id;
                            distribution.resourceName = array[index].resourceName;
                            distribution.full_name = array[index].full_name;
                            distribution.payment = array[index].payment;
                            distribution.amount = array[index].payment - array[index].amountPaidReceiver;
                            distribution.currencyResource = array[index].currency;
                            distribution.exchangeRate = array[index].exchangeRate;
                            this.distributionsOutgoingsNew.push(distribution);
                            let posReceiver = this.selectResourceReceiver.map(function(e) { return e.id; }).indexOf(distribution.resource_id);
                            this.selectResourceReceiver[posReceiver].amountPaidReceiver = this.selectResourceReceiver[posReceiver].amountPaidReceiver + distribution.amount
                            distribution = {};
                        }
                        this.editedOutgoingsItem.receiver = 'Organisation Project'
                        this.editedOutgoingsItem.amount = input.paymentProject;
                    }
                    else if (input.paymentAgency) {
                        console.log('newEditOutgoing test4', input.resources);
                        this.editedOutgoingsItem.accountable = 1;
                        if (input.payInDollars) {
                            this.editedOutgoingsItem.currency = '$';
                        } else {
                            this.editedOutgoingsItem.currency = 'S/.';
                        }
                        distribution = {};
                        distribution.outgoing_id = null;
                        this.editedOutgoingsItem.type_id = 7;
                        this.editedOutgoingsItem.organisation_id = input.resources[0].organisation_id;
                        this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverOrganisationId', this.editedOutgoingsItem.organisation_id);
                        // console.log('newEditOutgoing test1', this.editedOutgoingsItem.contact_id, this.selectResourceReceiver);
                        let array = input.resources;
                        for (let index = 0; index < array.length; index++) {
                            distribution.resource_id = array[index].id;
                            distribution.resourceName = array[index].resourceName;
                            distribution.full_name = array[index].full_name;
                            distribution.payment = array[index].payment;
                            distribution.amount = array[index].paymentOpen;
                            distribution.currencyResource = array[index].currency;
                            distribution.exchangeRate = array[index].exchangeRate;
                            this.distributionsOutgoingsNew.push(distribution);
                            let posReceiver = this.selectResourceReceiver.map(function(e) { return e.id; }).indexOf(distribution.resource_id);
                            // console.log('newEditOutgoing test3', posReceiver, distribution.resource_id);
                            this.selectResourceReceiver[posReceiver].amountPaidReceiver = this.selectResourceReceiver[posReceiver].amountPaidReceiver + distribution.amount
                            distribution = {};
                        }
                        this.editedOutgoingsItem.receiver = 'Organisation Tour Agency'
                        this.editedOutgoingsItem.amount = input.paymentAgency;
                        console.log('newEditOutgoing test2', this.editedOutgoingsItem.contact_id, this.selectResourceReceiver)
                    }
                    else if (input.refund) {
                        this.editedOutgoingsItem.currency = input.currency;
                        this.editedOutgoingsItem.accountable = 0;
                        this.editedOutgoingsItem.paymentMethod = 2;
                        this.editedOutgoingsItem.type_id = input.outgoingType;
                        this.editedOutgoingsItem.application_id = input.appId;
                        this.editedOutgoingsItem.receiver = 'Application';
                        this.tabGeneral = 1;
                        this.checkAppNr();
                    }
                }
                // this.editedOutgoingsItem.setAllDistributed = 0;
                this.editedOutgoingsItem.transaction_id = null;
                this.editedOutgoingsItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                this.editingOutgoing = false;
                this.dialogEditOutgoing = true;
            },

            closeEditOutgoing () {
                this.dialogEditOutgoing = false;
                this.editedOutgoingsItem = Object.assign({}, this.defaultOutgoingItem);
                this.editedOutgoingIndex = -1;
                this.distributionsOutgoingsNew = [];
                this.distributionsOutgoingsOld = [];
                this.classesPayment = [];
                this.$refs.formOutgoing.reset();
                this.loadingButton = false;
            },

            deleteOutgoing (item) {
                this.editedOutgoingIndex = this.outgoingsDay.indexOf(item)
                this.editedOutgoingsItem = Object.assign({}, item)
                this.dialogOutgoingDelete = true;
            },

            closeDeleteOutgoing () {
                this.editedOutgoingsItem = Object.assign({}, this.defaultOutgoingItem);
                this.editedOutgoingIndex = -1;
                this.dialogOutgoingDelete = false;
                this.loadingButton = false;
            },

            async deleteOutgoingConfirm () {
                this.loadingButton = true;
                if (this.editedOutgoingsItem.idSquare) {
                    await this.$store.dispatch('deleteSquare', this.editedOutgoingsItem.idSquare);
                    this.reloadLastSquare();
                } else {
                    await this.$store.dispatch('deleteOutgoing', this.editedOutgoingsItem.id);
                }
                this.cajaChicaDay = this.formattedDate(this.editedOutgoingsItem.dateTime, 'date');
                this.closeDeleteOutgoing();
                await this.getDataDay(this.cajaChicaDay);
                this.transactionsOutgoings = [];
            },

            async chooseReceiver(receiver) {
                console.log('chooseReceiver', receiver, this.editedOutgoingsItem);
                if (receiver === 'client') {
                    this.editedOutgoingsItem.contact_id = null;
                }
                if (receiver === 'contact') {
                    console.log('chooseReceiver #0a');
                    this.editedOutgoingsItem.client_id = null;
                    if (this.editedOutgoingsItem.type_id === 12 || this.editedOutgoingsItem.type_id === 13 || this.editedOutgoingsItem.type_id === 32) {
                        let tmp = this.editedOutgoingsItem.contact_id;
                        let teacherId = this.$store.state.activeTeachers.filter(function(select_item) {
                            return select_item.contact_id === tmp;
                        })[0].id;
                        this.selectClassesFinishedNotPaid(teacherId);
                    }
                }
                if (this.editedOutgoingsItem.contact_id) {
                    console.log('chooseReceiver #0b');
                    if (this.editedOutgoingsItem.type_id === 12 || this.editedOutgoingsItem.type_id === 13 || this.editedOutgoingsItem.type_id === 32) {
                        let contactId = this.editedOutgoingsItem.contact_id;
                        let teacher = this.$store.state.activeTeachers.filter(function(select_item) {
                            return select_item.contact_id === contactId;
                        })[0];
                        this.editedOutgoingsItem.discount_payment_teacher = teacher.discount_payment;
                    } else {
                        console.log('chooseReceiver #1', this.editedOutgoingsItem.contact_id);
                        this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverContactId', this.editedOutgoingsItem.contact_id);
                    }
                }
                if (this.editedOutgoingsItem.organisation_id) {
                    console.log('chooseReceiver #0c');
                    this.selectResourceReceiver = await this.$store.dispatch('getResourcesReceiverOrganisationId', this.editedOutgoingsItem.organisation_id);
                }
            },

            async loadTransactionsOutgoings(scope) {
                if (scope ===  'all') {
                    this.loadingbuttonLoadTransactionsClosed = true;
                    this.transactionsOutgoings = await this.$store.dispatch('getAllTransactionsOutgoings');
                    this.loadingbuttonLoadTransactionsClosed = false;
                } else {
                    this.loadingbuttonLoadTransactionsOpen = true;
                    this.transactionsOutgoings = await this.$store.dispatch('getOpenTransactionsOutgoings');
                    this.loadingbuttonLoadTransactionsOpen = false;
                }
            },

            async openAddDistributionsOutgoings () {
                console.log('openAddDistributionsOutgoings', this.selectResourceReceiver);

                this.selectResourceReceiverItems = [];

                for (let index = 0; index < this.selectResourceReceiver.length; index++) {
                    const receiver = this.selectResourceReceiver[index];

                    // 1️⃣ skip if already distributed
                    const alreadyDistributed = this.distributionsOutgoingsNew
                        .some(e => e.resource_id === receiver.id);

                    if (alreadyDistributed) continue;

                    // normalize values
                    const payment = this.decUtil.toDec(receiver.payment);
                    const amountPaid = this.decUtil.toDec(receiver.amountPaidReceiver);

                    // 2️⃣ skip if no payment
                    if (payment.isZero()) continue;

                    // 3️⃣ skip if fully paid
                    if (decUtil.equals(payment, amountPaid)) continue;

                    // 4️⃣ status check
                    if (receiver.statusResourceId >= 8) continue;

                    // 5️⃣ passed all rules → selectable
                    this.selectResourceReceiverItems.push(receiver);
                }

                // reset distributed amount
                this.amountDistributedOutgoings = this.decUtil.toDec(0);

                // open dialog or show error
                if (this.selectResourceReceiverItems.length > 0) {
                    this.dialog_add_distributionOutgoings = true;
                } else {
                    this.$store.dispatch('errorMessage', 'No resources to distribute');
                }
                
            },

            addDistributionOutgoings(distribution) {
                if (this.amountDistributedOutgoings === 0) {
                    this.$store.dispatch('errorMessage', 'Please add a amount to ditribute');
                    return;
                } else {
                    distribution.amount = Math.min(distribution.payment - distribution.amountPaidReceiver, this.amountDistributedOutgoings)
                }
                distribution.resource_id = distribution.id;
                distribution.currencyResource = distribution.currency;
                distribution.outgoings_id = this.editedOutgoingsItem.id;
                this.distributionsOutgoingsNew.push(distribution);
                let posReceiver = this.selectResourceReceiver.map(function(e) { return e.id; }).indexOf(distribution.resource_id);
                this.selectResourceReceiver[posReceiver].amountPaidReceiver = this.selectResourceReceiver[posReceiver].amountPaidReceiver + distribution.amount;
                this.dialog_add_distributionOutgoings = false;
            },

            async deleteDistributionOutgoing (event) {
                console.log('deleteDistributionOutgoing', event, this.distributionsOutgoingsNew, this.selectResourceReceiver);
                let pos = this.distributionsOutgoingsNew.map(function(e) { return e.resource_id; }).indexOf(event.resource_id);
                let posReceiver = this.selectResourceReceiver.map(function(e) { return e.id; }).indexOf(event.resource_id);
                this.selectResourceReceiver[posReceiver].amountPaidReceiver = this.selectResourceReceiver[posReceiver].amountPaidReceiver - event.amount
                if (pos > -1) {
                    this.distributionsOutgoingsNew.splice(pos, 1);
                }
                // this.calcAmountOutgoings();
            },

            async saveOutgoing() {
                this.nowDate = this.formattedDate(new Date(), 'date');
                if(this.$refs.formOutgoing.validate()) {
                    if ((this.editedIncomeItem.paymentMethod === 1 || this.editedIncomeItem.paymentMethod === 5) && this.lastSquareDateTime > this.formattedDate(this.editedOutgoingsItem.dateTime, 'dateTime')) {
                        this.$store.dispatch('errorMessage', 'Caja Chica already closed for that date')
                    } else {
                        var correctionTeacher = 0;
                        if (this.editedOutgoingsItem.type_id === 12 || this.editedOutgoingsItem.type_id === 13 || this.editedOutgoingsItem.type_id === 32) {
                            if (this.classesPayment.length === 0) {
                                this.$store.dispatch('errorMessage', 'No classes to pay');
                                return;
                            }

                            const discount = this.decUtil.toDec(this.discountPaymentTeachers);
                            const manualCorrection = this.decUtil.toDec(this.editedOutgoingsItem.correction);

                            const result = manualCorrection.minus(discount);

                            correctionTeacher = this.decUtil.format(result);

                        }
                        this.loadingButton = true;
                        if (this.tabGeneral === 0) {
                            this.editedOutgoingsItem.paymentMethod = 1;
                        }
                        if (this.editedOutgoingsItem.type_id === 27 || this.editedOutgoingsItem.type_id === 28 || this.editedOutgoingsItem.type_id === 41) {
                            this.editedOutgoingsItem.paymentMethod = 5;
                        }
                        if (this.editedOutgoingsItem.bankTransferFee === null) {
                            this.editedOutgoingsItem.bankTransferFee = 0;
                        }
                        this.editedOutgoingsItem.transaction_id = null;
                        if (this.editedOutgoingsItem.dateTime) {
                            if (this.formattedDate(this.editedOutgoingsItem.dateTime, 'date') === this.nowDate) {
                                this.editedOutgoingsItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                                // console.log("saveOutgoing #1", this.editedOutgoingsItem.dateTime);
                            } else {
                                this.editedOutgoingsItem.dateTime = this.formattedDate(this.editedOutgoingsItem.dateTime, 'dateTime');
                                // console.log("saveOutgoing #2", this.editedOutgoingsItem.dateTime);
                            }
                        } else {
                            this.editedOutgoingsItem.dateTime = this.formattedDate(new Date(), 'dateTime');
                        }
                        // console.log("saveOutgoing #3", this.editedOutgoingsItem.dateTime);
                        this.cajaChicaDay = this.formattedDate(this.editedOutgoingsItem.dateTime, 'date');
                        
                        if (this.editedOutgoingsItem.accountable === 1) {
                            if (this.editedOutgoingsItem.currency === '$') {
                                // assume this.distributionsTotalOutgoingsDollar is already a final value
                                this.editedOutgoingsItem.amount = this.decUtil.format(
                                    this.distributionsTotalOutgoingsDollar
                                );
                            } else {
                              // console.log('saveOutgoing #3a', this.distributionsTotalOutgoingsSoles, correctionTeacher);
                                const total = this.decUtil
                                .toDec(this.distributionsTotalOutgoingsSoles)
                                .plus(correctionTeacher);

                                this.editedOutgoingsItem.amount = this.decUtil.format(total);
                            }
                        }

                        this.editedOutgoingsItem.exchangeRate = this.$store.state.exchangeRate;
                        this.editedOutgoingsItem.executeStatusTrees = true;
                        // console.log("saveOutgoing #4", this.editedOutgoingsItem);
                        let newOutgoingId = await this.$store.dispatch('insertOutgoing', this.editedOutgoingsItem);
                        // console.log("saveOutgoing", this.distributionsOutgoingsOld, this.distributionsOutgoingsNew);
                        let multipleTreeResourceIds = [];
                        for (let index = 0; index < this.distributionsOutgoingsOld.length; index++) {
                            if (this.distributionsOutgoingsNew.map(function(e) { return e.id; }).indexOf(this.distributionsOutgoingsOld[index].id) === -1) {
                                // console.log("saveOutgoing #4b", this.distributionsOutgoingsOld[index].id);
                                await this.$store.dispatch('deleteDistributionOutgoingId', this.distributionsOutgoingsOld[index].id);
                                multipleTreeResourceIds.push(this.distributionsOutgoingsOld[index].resource_id);
                            }
                        }

                        let transaction_id = new Date();
                        for (let index = 0; index < this.distributionsOutgoingsNew.length; index++) {
                            if (newOutgoingId === 0) {
                                this.distributionsOutgoingsNew[index].outgoing_id = this.editedOutgoingsItem.id;
                            } else {
                                this.distributionsOutgoingsNew[index].outgoing_id = newOutgoingId;
                            }
                            this.distributionsOutgoingsNew[index].transaction_id = transaction_id.getTime();
                            this.distributionsOutgoingsNew[index].id = null;
                            // console.log("saveOutgoing #4c", this.distributionsOutgoingsNew[index].amount);
                            await this.$store.dispatch('insertDistributionOutgoings', this.distributionsOutgoingsNew[index]);
                            multipleTreeResourceIds.push(this.distributionsOutgoingsNew[index].resource_id);
                        }
                        await this.$store.dispatch('executeMultipleTrees', multipleTreeResourceIds);

                        if (this.editedOutgoingsItem.type_id === 12 || this.editedOutgoingsItem.type_id === 13 || this.editedOutgoingsItem.type_id === 32) {

                            for (let index = 0; index < this.classesPaymentOld.length; index++) {

                                const idx = this.classesPayment.findIndex(
                                    e => e.class_id === this.classesPaymentOld[index].class_id
                                );
                                
                                if (idx === -1) {
                                    this.classesPaymentOld[index].outgoing_id = null;
                                    this.classesPaymentOld[index].start = this.timeToTimeStamp(this.formattedDate(this.classesPaymentOld[index].start, "date"), this.formattedDate(this.classesPaymentOld[index].start, "time"));
                                    this.classesPaymentOld[index].end = this.timeToTimeStamp(this.formattedDate(this.classesPaymentOld[index].end, "date"), this.formattedDate(this.classesPaymentOld[index].end, "time"));

                                    await this.$store.dispatch('insertClass', this.classesPaymentOld[index])
                                }
                            }
                            for (let index = 0; index < this.classesPayment.length; index++) {

                                const current = this.classesPayment[index];

                                const idx = this.classesPaymentOld.findIndex(
                                    e => e.class_id === current.class_id
                                );

                                if (idx === -1) {
                                    this.classesPayment[index].outgoing_id = newOutgoingId;
                                    this.classesPayment[index].start = this.timeToTimeStamp(
                                        this.formattedDate(this.classesPayment[index].start, "date"),
                                        this.formattedDate(this.classesPayment[index].start, "time")
                                    );
                                    this.classesPayment[index].end = this.timeToTimeStamp(
                                        this.formattedDate(this.classesPayment[index].end, "date"),
                                        this.formattedDate(this.classesPayment[index].end, "time")
                                    );

                                    await this.$store.dispatch('insertClass', this.classesPayment[index]);
                                }
                            }
                        }
                        this.balanceGeneralYear = this.formattedDate(this.editedOutgoingsItem.dateTime, 'year');
                        this.tabMonth = parseInt(this.formattedDate(this.editedOutgoingsItem.dateTime, 'month')) - 1;
                        this.closeEditOutgoing();
                        await this.getDataDay(this.cajaChicaDay);
                        this.transactionsOutgoings = [];
                        this.classesPayment = [];
                    }
                }
            },
            
            changeOutgoingType() {
                this.editedOutgoingsItem.client_id = null;
                this.editedOutgoingsItem.contact_id = null;
                this.editedOutgoingsItem.organisation_id = null;
                this.editedOutgoingsItem.application_id = null;

                const typeId = this.editedOutgoingsItem.type_id;

                const outgoingItem = this.typesOutgoings.find(o => o.id === typeId);
                if (!outgoingItem) return;

                this.editedOutgoingsItem = {
                    ...this.editedOutgoingsItem,
                    accountable: outgoingItem.accountable,
                    receiver: outgoingItem.receiver,
                    contact_id: outgoingItem.contact_id,
                    currency:
                        (typeId === 12 || typeId === 13 || typeId === 32)
                            ? 'S/.'
                            : (typeId === 73 ? '€' : (this.editingOutgoing ? this.editedOutgoingsItem.currency : '$')),
                    paymentMethod: outgoingItem.paymentMethod || this.editedOutgoingsItem.paymentMethod,
                    fixedPaymentMethod: outgoingItem.paymentMethod ? 1 : 0
                };
            },

            async openEditOutgoings (event) {
                console.log('openEditOutgoings', event)
                this.balanceGeneralYear = this.formattedDate(event.paidOn, 'year');
                // this.tabMonth = parseInt(this.formattedDate(event.paidOn, 'month')) - 1;
                await this.getDataDay(event.paidOn)
                let tmp = event.outgoing_id;
                let item = this.outgoingsMonth.filter(function(select_item) {
                    return select_item.id === tmp;
                })[0]
                this.editOutgoing(item);
                this.dialogTransactionOutgoings = false;
                this.$store.dispatch('saveDataForReport', ); 
            },

            selectAvailableAgencies () {
                return this.$store.state.available_agencies.filter(function(select_item) {
                    return select_item.obsolete === null;
                })
            },

            selectContactsIncome () {
                return this.$store.state.contacts.filter(function(select_item) {
                    return select_item.obsolete === null;
                })
            },

            selectPaymentMethods () {
                if (this.tabGeneral === 0) {
                    this.editedIncomeItem.paymentMethod = 1;
                    this.editedOutgoingsItem.paymentMethod = 1;
                } else {
                    let result = this.$store.state.paymentMethods.filter(function(select_item) {
                        return select_item.obsolete === null;
                    })
                    if (this.tabGeneral === 3) {
                        result.push({id: null, method: 'Variable payment method'});
                    }
                    return result;
                }
            },

            async changeDate (event) {
                console.log('changeDate', event);
                this.$store.dispatch('setLoadingApp', 1)
                this.cajaChicaDay = event;
                await this.getDataDay(event);
                this.$store.dispatch('setLoadingApp', 0);
            },

            addDays(startDate, days) {
                let new_date = dayjs(startDate).add(days, 'd');
                let day = new_date.format('DD');
                let month = new_date.format('MM');
                let year = new_date.format('YYYY');
                return year + '-' + month + '-' + day
            },

            async squareCaja() {
                this.loadingButton = true;

                try {
                    const square = {
                    exchangeRate: this.$store.state.exchangeRate,
                    dateTime: this.formattedDate(new Date(), 'dateTime'),
                    comments: this.buildSquareComments()
                    };

                    await this.$store.dispatch('insertSquare', square);

                    this.reloadLastSquare();
                    this.cajaChicaDay = this.formattedDate(this.nowDate, 'date');
                    await this.getDataDay(this.cajaChicaDay);

                    this.editedIncomeItem = { ...this.defaultIncomeItem };
                    this.editedOutgoingsItem = { ...this.defaultOutgoingItem };

                } finally {
                    this.loadingButton = false;
                }
            },

            buildSquareComments() {
                const safe = (val) => Number(val ?? 0);

                const solesCash = safe(this.currentBalances?.[1]).toFixed(2);
                const dollarsCash = safe(this.currentBalances?.[0]).toFixed(2);
                const solesBank = safe(this.currentBalances?.[3]).toFixed(2);
                const dollarsBank = safe(this.currentBalances?.[2]).toFixed(2);

                return `S/.${solesCash} $${dollarsCash} | S/.${solesBank} $${dollarsBank}`;
            },

            async goApplication(id) {
                await this.$store.dispatch('saveDataForReport', id);
                this.$router.push({ name: 'Application' })
            },

            checkShow() {
                const distributed = this.decUtil.toDec(this.distributionsTotalIncome);

                // if nothing distributed yet → show
                if (distributed.isZero()) {
                    return true;
                }

                const amount = this.decUtil.toDec(this.editedIncomeItem.amount);
                const fee = this.decUtil.toDec(this.editedIncomeItem.bankTransferFee);
                const exchangeRate = this.decUtil.toDec(this.$store.state.exchangeRate);

                const feeIncluded =
                    this.transferFeeIncluded === true || this.transferFeeIncluded === 1;

                let expected;

                if (this.editedIncomeItem.currency === '$') {
                    // USD base
                    expected = feeIncluded ? amount.plus(fee) : amount;
                } else {
                    // non-USD → convert
                    const base = feeIncluded ? amount.plus(fee) : amount;
                    expected = base.times(exchangeRate);
                }

                // show if NOT equal (default tolerance = 0.01)
                console.log('checkShow', decUtil.equals(distributed, expected));
                return !decUtil.equals(distributed, expected);
            },

            getTransferFeeIncluded(agency_id) {
                return this.$store.state.available_agencies.filter(function(select_item) {
                    return select_item.id === agency_id;
                })[0].transferFeeIncluded;
            },

            async selectClassesFinishedNotPaid(teacherId) {
                this.classesPayment = await this.$store.dispatch('getClassesTeacherIdFinishedNotPaid', teacherId);
                if (this.classesPayment.length === 0) {
                    this.$store.dispatch('warningMessage', 'No classes to pay');
                    this.distributionsOutgoingsNew = [];
                } else {
                    this.prepareClassesNotPaid(null);
                }
            },

            async prepareClassesNotPaid(outgoingId) {
                this.$store.dispatch('setLoadingApp', 1);

                try {
                    // ----------------------------------
                    // Reset state
                    // ----------------------------------
                    this.distributionsOutgoingsOld = JSON.parse(
                    JSON.stringify(this.distributionsOutgoingsNew)
                    );
                    this.distributionsOutgoingsNew = [];

                    // ----------------------------------
                    // Build SQL condition
                    // ----------------------------------
                    const classIds = this.classesPayment.map(c => c.class_id);
                    const sqlTxt = classIds
                    .map(id => `class_id = ${id}`)
                    .join(' OR ');

                    this.addStudentsShortToClassesPayment();

                    // ----------------------------------
                    // Load resources
                    // ----------------------------------
                    const resourcesInClasses = JSON.parse(
                      JSON.stringify(
                          await this.$store.dispatch('getResourcesClassesSafe', sqlTxt)
                      )
                    );

                    // ----------------------------------
                    // Fast lookup by resource_id
                    // ----------------------------------
                    const distributionsMap = new Map();

                    for (const cls of this.classesPayment) {
                      const perStudentPayment = this.decUtil
                          .toDec(cls.paymentClass)
                          .div(cls.amount_students);

                      const resourcesInClass = resourcesInClasses.filter(
                          r => r.class_id === cls.class_id
                      );

                      for (const r of resourcesInClass) {
                          const key = r.resource_id;

                          if (distributionsMap.has(key)) {
                          const existing = distributionsMap.get(key);
                          existing.amountDec = existing.amountDec.plus(
                              perStudentPayment
                          );
                          } else {
                          distributionsMap.set(key, {
                              outgoing_id: outgoingId,
                              resource_id: r.resource_id,
                              resourceName: r.resourceName,
                              full_name: r.full_name,
                              payment: r.payment,
                              currencyResource: 'S/.',
                              exchangeRate: r.exchangeRate,
                              amountDec: perStudentPayment
                          });
                          }
                      }
                    }

                    // ----------------------------------
                    // Finalize (IO boundary)
                    // ----------------------------------
                    this.distributionsOutgoingsNew = Array.from(
                      distributionsMap.values()
                    ).map(d => ({
                      ...d,
                      amount: this.decUtil.format(d.amountDec, 4)
                    }));

                } finally {
                    this.$store.dispatch('setLoadingApp', 0);
                }
            },

            async deleteClassesPayment (event) {
                // console.log("deleteClassesPayment", event);
                this.$store.dispatch('setLoadingApp', 1);
                if (this.classesPayment.length === 1) {
                    this.$store.dispatch('errorMessage', 'There needs to be at least 1 class to pay');
                    this.$store.dispatch('setLoadingApp', 0);
                    return;
                }
                let pos = this.classesPayment.map(function(e) { return e.class_id; }).indexOf(event.class_id);
                if (pos > -1) {
                    this.classesPayment.splice(pos, 1);
                }
                await this.prepareClassesNotPaid(this.editedOutgoingsItem.id);
                this.$store.dispatch('setLoadingApp', 0);
            },

            async openAnnualReport() {
                let payload =[];
                payload.year = this.balanceGeneralYear;
                await this.$store.dispatch('saveDataForReport', payload);
                this.$router.push({ name: 'AnnualReport'});
            },

            async initFinanciallocked() {
                await this.$store.dispatch('getGeneralSettings');
                this.financialLocked = dayjs(this.$store.state.financialLocked).format("YYYY-MM-DD");
                this.financialFirstOpenDay = dayjs(this.financialLocked).add(1, 'd').format("YYYY-MM-DD");
                this.lockedFinancialMonth = dayjs(this.financialLocked).format("YYYY-MM");
            },

            async saveFinancialLocked() {
                this.financialLocked = dayjs(this.lockedFinancialMonth).endOf('month').format('YYYY-MM-DD')
                await this.$store.dispatch('saveFinancialLocked', this.financialLocked);
                await this.initFinanciallocked();
                await this.getDataMonth(this.tabMonth);
            },

            getLastDateOfMonth(month) {
                let yearmonth = dayjs(this.balanceGeneralYear + '-' + month).format('YYYY-MM');
                return dayjs(yearmonth).endOf('month').format('YYYY-MM-DD');
            },

            async calcDistributed() {
                if (this.editedIncomeItem.currency === '$') {
                    this.amountDistributedIncome = Math.min(this.editedIncomeItem.amount, this.amountDistributedIncome);
                }
            },

            switchMonthDialogValutaYear(upOrDown) {
                if(upOrDown === 'down' && this.tabMonth > 0) {
                    this.tabMonth -= 1;
                } else if (upOrDown === 'up' && this.tabMonth < 11) {
                    this.tabMonth += 1;
                } else {
                    return;
                }
                this.getDataMonth(this.tabMonth);
                if (this.dialogValutaYearTitle === 'Balance Soles Bank') {
                    this.openReportValutaYear('solesBank');
                } else if (this.dialogValutaYearTitle === 'Balance Dollars Bank') {
                    this.openReportValutaYear('dollarsBank');
                } else if (this.dialogValutaYearTitle === 'Balance Dollars Wise') {
                    this.openReportValutaYear('dollarsWise');
                } else if (this.dialogValutaYearTitle === 'Balance Euros Wise') {
                    this.openReportValutaYear('eurosWise');
                } else if (this.dialogValutaYearTitle === 'Balance GBP Wise') {
                    this.openReportValutaYear('gbpWise');
                }
            },

            async openReportValutaYear(account) {
                if (account === 'solesBank') {
                    this.valutaYear = await this.$store.dispatch('getSolesBankTable', this.formattedDate(dayjs(this.getLastDateOfMonth(this.tabMonth + 1)).add(1, 'day'), 'date'));
                    this.dialogValutaYearTitle = 'Balance Soles Bank';
                } else if (account === 'dollarsBank') {
                    this.valutaYear = await this.$store.dispatch('getDollarsBankTable', this.formattedDate(dayjs(this.getLastDateOfMonth(this.tabMonth + 1)).add(1, 'day'), 'date'));
                    this.dialogValutaYearTitle = 'Balance Dollars Bank';
                } else if (account === 'dollarsWise') {
                    this.valutaYear = await this.$store.dispatch('getDollarsWiseTable', this.formattedDate(dayjs(this.getLastDateOfMonth(this.tabMonth + 1)).add(1, 'day'), 'date'));
                    this.dialogValutaYearTitle = 'Balance Dollars Wise';
                } else if (account === 'eurosWise') {
                    this.valutaYear = await this.$store.dispatch('getEurosWiseTable', this.formattedDate(dayjs(this.getLastDateOfMonth(this.tabMonth + 1)).add(1, 'day'), 'date'));
                    this.dialogValutaYearTitle = 'Balance Euros Wise';
                } else if (account === 'gbpWise') {
                    this.valutaYear = await this.$store.dispatch('getGBPWiseTable', this.formattedDate(dayjs(this.getLastDateOfMonth(this.tabMonth + 1)).add(1, 'day'), 'date'));
                    this.dialogValutaYearTitle = 'Balance GBP Wise';
                } else {
                    return;
                }
                this.valutaYear[0].balance = this.decUtil.format(
                    this.decUtil.toDec(this.valutaYear[0].amount || 0)
                );
                this.valutaYear[0].dateTime = dayjs(this.valutaYear[0].dateTime).format('YYYY-MM-DD');
                this.valutaYear = this.valutaYear.sort(this.dynamicSort('dateTime'));
                let beginOfMonth = this.getLastDateOfMonth(this.tabMonth + 1).slice(0,8);
                beginOfMonth += '01';
                this.valutaMonth = [];
                for (let index = 1; index < this.valutaYear.length; index++) {
                    this.valutaYear[index].dateTime = dayjs(this.valutaYear[index].dateTime).format('YYYY-MM-DD');

                    const prevBalance = this.decUtil.toDec(this.valutaYear[index - 1].balance);
                    const amount = this.decUtil.toDec(this.valutaYear[index].amount || 0);
                    const fee = this.decUtil.toDec(this.valutaYear[index].bankTransferFee || 0);

                    let newBalance;

                    if (this.valutaYear[index].move === 'OUT') {
                        newBalance = prevBalance.plus(amount).plus(fee);
                    } else {
                        newBalance = prevBalance.plus(amount);
                    }

                    this.valutaYear[index].balance = this.decUtil.format(newBalance);

                    if (this.valutaYear[index].dateTime >= beginOfMonth) {
                        this.valutaMonth.push(this.valutaYear[index]);
                    }
                }
                
                this.dialogValutaYear = true;
            },

            async checkAppNr() {
                
                if (this.editedOutgoingsItem.application_id) {
                    let application = await this.$store.dispatch('getApplicationId', this.editedOutgoingsItem.application_id);
                    if (!application) {
                        this.$store.dispatch('errorMessage', 'Application number does not exist');
                        this.editedOutgoingsItem.application_appTitle = '';
                    } else {
                        this.editedOutgoingsItem.application_appTitle = application.appTitle;
                    }
                }
            
            },

            goClient(id) {
                this.$store.dispatch('setLoadingApp', 1);
                this.$router.push({ name: 'Client', params: { id: id } })
            },

            timeToTimeStamp(day, time) {
                // console.log("timeToTimeStamp", day, time)
                let minStart = time.substring(time.length - 2, time.length);
                let hourStart = time.substring(0, time.length - 3);
                // console.log('timeToTimeStamp', this.toTimestamp(this.formattedDate(dayjs(day).hour(hourStart).minute(minStart), "dateTime")))
                return this.toTimestamp(this.formattedDate(dayjs(day).hour(hourStart).minute(minStart), "dateTime"));
            },

            toTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum;
            },

            createStudentsStringfromObject(studentsObject) {
                // console.log('createStudentsStringfromObject', studentsObject)
                if (studentsObject !== null) {
                    let students = studentsObject;
                    let result = '';
                    for (let i = 0; i < students.length; i++) {
                        (i > 0) ? result = result.concat(', ') : result = result.concat('')
                        if (students[i].initial_spanish_level && students[i].initial_spanish_level !== '?') {
                            result = result.concat(students[i].full_name, ' (' + students[i].initial_spanish_level, ')')
                        } else {
                            result = result.concat(students[i].full_name)
                        }
                    }
                    return result;
                } else {
                    return 'ERROR';
                }
            },

            changePaymentMethodOutgoing(event) {
                console.log('changePaymentMethodOutgoing', event);
                this.editedOutgoingsItem.paymentMethod = event;
                // this.renderDialog = Math.random();
            },

            async createPaymentTeacherForm(outgoing) {
                console.log('createPaymentTeacherForm');
                this.$store.dispatch('setLoadingApp', 1);

                const classesPaid = await this.$store.dispatch(
                    'getClassesOutgoingId',
                    outgoing.id
                );

                console.log('createPaymentTeacherForm #1', classesPaid);

                // -----------------------------
                // Basic data
                // -----------------------------
                const teacher = {
                    contact: outgoing.contactName,
                    email: outgoing.email,
                    id: outgoing.teacherId
                };

                const correction = this.decUtil.toDec(outgoing.correction);
                const discountPercent = this.decUtil.toDec(outgoing.discount_payment_teacher || 0);
                const totalPayment = this.decUtil.toDec(outgoing.amount);
                const commentsCorrection = outgoing.comments_correction || '';

                // -----------------------------
                // Payment math (canonical)
                // -----------------------------
                // subTotal = (total - correction) / (1 - discount%)
                const discountRate = discountPercent.div(100);
                const oneMinusDiscount = this.decUtil.toDec(1).minus(discountRate);

                const subTotalPayment = totalPayment
                    .minus(correction)
                    .div(oneMinusDiscount);

                const discountAFPayment = subTotalPayment.times(discountRate);

                // -----------------------------
                // Classes processing (non-money)
                // -----------------------------
                let totalMinutes = 0;

                for (let i = 0; i < classesPaid.length; i++) {
                    const cls = classesPaid[i];

                    cls.students = await this.createStudentsStringfromObject(
                    cls.studentsObject
                    );

                    totalMinutes += cls.duration;

                    cls.description =
                    `${cls.class_type}-${cls.class_group}: ` +
                    `(${cls.amount_students}) ${cls.students}`;

                    cls.description = cls.description.substring(0, 80);
                }

                classesPaid.sort(this.dynamicSort('start'));

                // -----------------------------
                // HTML generation (IO boundary)
                // -----------------------------
                const formHeader = `
                    <div style="margin-top: 0cm; display: flex; flex-direction: column; font-family: Raleway, Arial, Helvetica, sans-serif;">
                    <div style="display: flex; flex-direction: row; justify-content: space-between; margin: 0 0 2cm 0;">
                        <div style="font-family: Roboto, sans-serif; font-size: 32px; color: #35b729;">
                        <span>PROYECTO</span><strong>PERU</strong>
                        </div>
                        <div style="font-size: 32px; color: grey; display: flex; flex-direction: column; align-items: flex-end;">
                        <div>PAGO PROFE</div>
                        <div style="font-size: 24px;">${teacher.contact}</div>
                        <div style="font-size: 18px;">${this.formattedDate(Date.now())}</div>
                        </div>
                    </div>
                    </div>
                `;

                const rows = classesPaid.map(cls => {
                    const hourlyRate = this.decUtil.format(
                        this.decUtil.toDec(cls.paymentClass).div(cls.duration / 60)
                    );

                    return `
                        <tr style="font-size: 12px">
                        <td>${this.formattedDate(cls.start, 'dateAndTime')} (${cls.duration})</td>
                        <td>${cls.description}</td>
                        <td>${hourlyRate}</td>
                        <td>${decUtil.format(cls.paymentClass)}</td>
                        </tr>
                    `;
                }).join('');

                const formBody = `
                    <div>
                        <table style="width: 100%;">
                            <tr>
                            <th style="text-align: left; width: 140px;">Fecha/hora (min)</th>
                            <th style="text-align: left;">Descripcion</th>
                            <th style="text-align: left; width: 120px;">Tarifa (hr)</th>
                            <th style="text-align: left;">Pago</th>
                            </tr>
                            ${rows}
                        </table>
                    </div>
                `;

                const formFooter = `
                    <div style="margin-top: 0.5cm; background-color: #c7d3d1; height: 2px;"></div>

                    <div style="width: 100%; display: flex; flex-direction: column;">
                    <div style="display: flex; justify-content: flex-end">
                        <div>
                        <div style="text-align: right">
                            Subtotal:&nbsp;&nbsp;&nbsp;${decUtil.format(subTotalPayment)}
                        </div><br/>

                        <div style="text-align: right">
                            AFP ${discountPercent.toString()}%:&nbsp;&nbsp;&nbsp;- ${decUtil.format(discountAFPayment)}
                        </div><br/>

                        <div style="text-align: right">
                            Corrección ${commentsCorrection}:&nbsp;&nbsp;&nbsp;${decUtil.format(correction)}
                        </div>
                        </div>
                    </div>

                    <br/><br/>

                    <div style="margin-top: 0.5cm; background-color: #c7d3d1; height: 2px;"></div>

                    <div style="display: flex; justify-content: flex-end">
                        <h3>
                        Total: S/.${decUtil.format(totalPayment)}<br/>
                        ${totalMinutes / 60} horas
                        </h3>
                    </div>
                    </div>
                `;

                // -----------------------------
                // Output
                // -----------------------------
                this.outputData = {
                    submittedFrom: 'PaymentTeacherForm',
                    formHTML: `${formHeader}${formBody}${formFooter}`,
                    emailList: [teacher.email],
                    emailSubject: `Pago Profe ${teacher.contact}`,
                    emailTeacherId: teacher.id,
                    teacher: teacher.contact
                };

                this.dialogForm = true;
                this.$store.dispatch('setLoadingApp', 0);
            },

            async printNow (html) {
                console.log('printNow ')
                print(html);
            },

            


        }
    }
</script>

<style>
    .green-background {
        background-color: turquoise;
    }
    .orange-background {
        background-color: lightsalmon;
    }
    .white-background {
        background-color: white;
    }
    .blue-background {
        background-color: lightsteelblue;
    }
    .red-background {
        background-color: rgb(249, 94, 94);
    }
    .smallText {
        font-size: 10px;
    }
    .clickable-table tbody tr:hover {
        cursor: pointer;
    }
</style>